/*
================================================================ 
     Copyright (c) 2018-2020 Digitize Things Inc.           
           All rights reserved.                       
================================================================ 
*/

import React, { useCallback, useEffect, useState, useRef } from "react";
import classes from "../checkout.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import totalCalculator from "../../../../helper/totalCalculator";
import totalCalculatorNew from "../../../../helper/totalCalculatorNew";
import { withTranslation } from "react-i18next";
import Input from "../../../../component/inputpm";
import {
  CardActions,
  CardContent,
  TableContainer,
  Tooltip,
} from "@mui/material";
import currencyFormatter from "../../../../helper/currencyFormatter";
import Collapse from "@mui/material/Collapse";
import { connect } from "react-redux";
import ButtonComponent from "../../../../component/button";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ClearIconMUI from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InventoryDetails from "./inventoryDetails";
import Card from "@mui/material/Card";
import { ViewIconNew } from "../../../../component/icons/icons";
import { IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  DeleteIconNew,
  EnterArrow,
  EditIconNew,
  ClipboardWithGear,
} from "../../../../component/icons/icons";
import Grid from "@mui/material/Grid";
import ShowNoteDialog from "./showNoteDialog";
import Button from "../../../../component/button";
import CloseIcon from "@mui/icons-material/Close";
import { formatNumber } from "../../../../helper/numberFormatter";
import { formatDate } from "../../../../helper/dateFormatter";
// import { makeStyles } from '@mui/styles';
import OfferingProductSpecCharacteristicsExistingDialog from "../../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog";
import { Link } from "react-router";

const CartBlock = (props) => {
  const t = props.t;
  const [priceDueNow, setPriceDueNow] = useState(0);
  const [priceDueAtInstallation, setPriceDueAtInstallation] = useState(0);
  const [cancellationPriceTotal, setCancellationPriceTotal] = useState(0);
  const [shiftPriceTotal, setShiftPriceTotal] = useState(0);
  const [suspendPriceTotal, setSuspendPriceTotal] = useState(0);
  const [resumePriceTotal, setResumePriceTotal] = useState(0);
  const [priceRecurringCharge, setPriceRecurringCharge] = useState(0);
  const [priceRecurringChargeTotal, setPriceRecurringChargeTotal] = useState(
    [],
  );
  const [priceNTCtotal, setPriceNTCtotal] = useState([]);

  const [newestNotes, setNewestNotes] = useState(props.note.slice(0, 3));
  const [allNotesOpen, setAllNotesOpen] = useState(false);

  // const useStyles = makeStyles({
  // 	resizablePaper: {
  // 		resize: 'both',
  // 		overflow: 'auto',
  // 		minWidth: 640,
  // 		minHeight: 200,
  // 		maxWidth: '90vw',
  // 		maxHeight: '90vh',
  // 		width: '60vw',
  // 	}
  // });
  // const classess = useStyles();

  const checkFulfillable = (value) => {
    if (value === false) {
      return false;
    } else {
      return true;
    }
  };
  const getPriceTenureUOM = (val) => {
    // console.log('getpricetemure===', val);
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "DATA_MB") {
      return "MB";
    } else if (val === "DATA_GB") {
      return "GB";
    } else {
      return "";
    }
  };

  const calculatePrices = useCallback(() => {
    let dueNowTotal = 0;
    let dueAtInstallationTotal = 0;
    let recurringTotal = 0;
    let cancellationPriceTotal = 0;
    let shiftPriceTotal = 0;
    let suspendPriceTotal = 0;
    let resumePriceTotal = 0;
    var updatedList = [];
    var NTC_List = [];

    const cartData = props.solutionList;
    cartData.forEach((item) => {
      item.associatedItems.forEach((associatedItems) => {
        associatedItems.otherPrices &&
          associatedItems.otherPrices.length > 0 &&
          associatedItems.otherPrices.forEach((price) => {
            switch (price.priceType) {
              case "ADVANCE":
              case "DEPOSIT":
                dueNowTotal +=
                  price.price * associatedItems.quantity * item.quantity;
                break;
              case "SETUP_FEE":
                dueAtInstallationTotal +=
                  price.price * associatedItems.quantity * item.quantity;
                break;
              case "RC":
                recurringTotal +=
                  price.price * associatedItems.quantity * item.quantity;
                break;
              case "CANCELLATION_PRICE":
                cancellationPriceTotal +=
                  price.price * associatedItems.quantity * item.quantity;
                break;
              case "SHIFT_PRICE":
                shiftPriceTotal +=
                  price.price * associatedItems.quantity * item.quantity;
                break;
              case "SUSPENSION_PRICE":
                suspendPriceTotal +=
                  price.price * associatedItems.quantity * item.quantity;
                break;
              case "REACTIVATION_PRICE":
                resumePriceTotal +=
                  price.price * associatedItems.quantity * item.quantity;
                break;
              case "USAGE_CHARGE":
                var key = `${price.priceTenure}_${price.priceTenureUOM}`;
                var found = false;
                for (var k = 0; k < updatedList.length; k++) {
                  if (updatedList[k].key === key) {
                    updatedList[k].price +=
                      price.price * associatedItems.quantity * item.quantity;
                    found = true;
                    break;
                  }
                }
                if (!found) {
                  var newObj = {
                    key: key,
                    termPeriod: price.priceTenure,
                    tenureUom: price.priceTenureUOM,
                    price:
                      price.price * associatedItems.quantity * item.quantity,
                  };
                  updatedList.push(newObj);
                }
                break;
              default:
                break;
            }
          });
      });
    });
    // cartData.forEach(item => {
    //     item.associatedItems.forEach(associatedItems => {
    //         switch (associatedItems.chargeType) {
    //             case "RC":
    //                 recurringTotal += (associatedItems.amount * associatedItems.quantity) * item.quantity;
    //                 break;
    //             default:
    //                 dueAtInstallationTotal += (associatedItems.amount * associatedItems.quantity) * item.quantity;
    //                 break;
    //         }
    //     })
    // })
    cartData.forEach((item) => {
      item.associatedItems.forEach((associatedItems) => {
        associatedItems.amount = Math.round(associatedItems.amount * 100) / 100;
        if (associatedItems.chargeType === "RC") {
          if (associatedItems.chargeTerm) {
            var key = `${associatedItems.chargeTerm.termPeriod}_${associatedItems.chargeTerm.termUomId}`;
            var found = false;
            for (var k = 0; k < updatedList.length; k++) {
              if (updatedList[k].key === key) {
                updatedList[k].price +=
                  associatedItems.amount *
                  associatedItems.quantity *
                  item.quantity;
                found = true;
                break;
              }
            }
            if (!found) {
              var newObj = {
                key: key,
                termPeriod: associatedItems.chargeTerm.termPeriod,
                tenureUom: associatedItems.chargeTerm.termUomId,
                price:
                  associatedItems.amount *
                  associatedItems.quantity *
                  item.quantity,
              };
              updatedList.push(newObj);
            }
          }
        } else if (associatedItems.chargeType === "NTC") {
          if (associatedItems.chargeTerm) {
            var key = `${associatedItems.chargeTerm.termPeriod}_${associatedItems.chargeTerm.termUomId}`;
            var found = false;
            for (var k = 0; k < NTC_List.length; k++) {
              if (NTC_List[k].key === key) {
                NTC_List[k].price +=
                  associatedItems.amount *
                  associatedItems.quantity *
                  item.quantity;
                found = true;
                break;
              }
            }
            if (!found) {
              var newObj = {
                key: key,
                termPeriod: associatedItems.chargeTerm.termPeriod,
                tenureUom: associatedItems.chargeTerm.termUomId,
                price:
                  associatedItems.amount *
                  associatedItems.quantity *
                  item.quantity,
              };
              NTC_List.push(newObj);
            }
          }
        } else {
          dueAtInstallationTotal +=
            associatedItems.amount * associatedItems.quantity * item.quantity;
        }
      });
    });
    setPriceDueNow(dueNowTotal);
    setPriceDueAtInstallation(dueAtInstallationTotal);
    setCancellationPriceTotal(cancellationPriceTotal);
    setShiftPriceTotal(shiftPriceTotal);
    setSuspendPriceTotal(suspendPriceTotal);
    setResumePriceTotal(resumePriceTotal);
    // setPriceRecurringCharge(recurringTotal);
    setPriceRecurringChargeTotal(updatedList);
    setPriceNTCtotal(NTC_List);
  }, [props.solutionList]);

  useEffect(() => {
    if (props.priceSummaryView) {
      if (props.solutionList) {
        calculatePrices();
      }
    }
  }, [props.priceSummaryView, props.solutionList, calculatePrices]);

  const [inventoryDetail, setInventoryDetail] = useState({
    name: "",
    inventory: [],
    show: false,
  });
  const toggleInventoryDialog = (name, inventory) => {
    if (name && inventory) {
      setInventoryDetail({
        name: name,
        inventory: inventory,
        show: true,
      });
    } else {
      setInventoryDetail({
        name: "",
        inventory: {},
        show: false,
      });
    }
  };

  const [showNote, setShowNote] = useState(false);
  const [noteData, setNotedata] = useState({});
  const showFullNote = (note) => {
    setNotedata(note);
    setShowNote(true);
  };
  const closeFullNote = () => {
    setNotedata({});
    setShowNote(false);
  };

  const handleOpenAllNotes = () => {
    setAllNotesOpen(true);
  };

  const handleCloseAllNotes = () => {
    setAllNotesOpen(false);
  };

  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  // Get total amount from total calculator component
  const {
    nowTotal,
    recTotal,
    nowDiscountedPrice,
    recDiscountedPrice,
    totalDiscount,
  } = props.priceSummaryView
      ? totalCalculatorNew(
        props.componentList,
        props.solutionList,
        props.accessoryList,
        props.tenantId,
        props.totalRCDiscount,
        props.totalNRDiscount,
      )
      : totalCalculator(
        props.componentList,
        props.solutionList,
        props.accessoryList,
        props.tenantId,
        props.totalRCDiscount,
        props.totalNRDiscount,
      );
  return (
    <div>
      {/* new UI for when priceSummary is true */}
      <Grid
        item
        style={{ display: "flex", justifyContent: "space-between" }}
        size={{
          xs: 12,
          md: 8,
        }}
      >
        <div>
          <h3 style={{ marginTop: 0 }}>{t("ORDER_ITEMS")}</h3>
        </div>
      </Grid>
      <Grid container spacing={1}>
        {props.priceSummaryView ? (
          <>
            <Grid
              item
              className={classes.cartItemContainer}
              size={{
                xs: 12,
                md: 8,
              }}
            >
              {props.solutionList.map((item, index) => (
                // updated
                <React.Fragment key={index}>
                  <Card
                    variant="outlined"
                    className={"roundCorners " + classes.cartItemCard}
                  >
                    <Grid container className={classes.cardItemHeader}>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 8,
                        }}
                      >
                        <b>
                          <Link target="_blank" to={`/viewProduct/${item.id}?type=myOfferings`} style={{ color: 'inherit' }}>{item.name}</Link>
                        </b>

                        {/* <Tooltip title={t("EDIT")}>
													<IconButton className="buttonSecondary">
														{" "}
														<EditIconNew />{" "}
													</IconButton>
												</Tooltip> */}
                      </Grid>
                      <Grid
                        item
                        justifyContent="flex-end"
                        size={{
                          xs: 12,
                          md: 4,
                        }}
                      >
                        <>
                          {props.edit.quantity ? (
                            <Input
                              className={classes.quantityInput}
                              type="number"
                              min="1"
                              step="1"
                              value={item.quantity}
                              onChange={(e) => {
                                props.changeQuantity(
                                  e.target.value,
                                  index,
                                  "SOL",
                                );
                                item.discount &&
                                  props.changeDiscount(
                                    item.discount,
                                    index,
                                    "SOL",
                                  );
                              }}
                              style={{ background: "#fff" }}
                            />
                          ) : (
                            <Input
                              className={classes.quantityInput}
                              type="number"
                              min="1"
                              step="1"
                              value={item.quantity}
                              onChange={(e) => {
                                props.changeQuantity(
                                  e.target.value,
                                  index,
                                  "SOL",
                                );
                                item.discount &&
                                  props.changeDiscount(
                                    item.discount,
                                    index,
                                    "SOL",
                                  );
                              }}
                              style={{ background: "#fff" }}
                              disabled
                            />
                          )}
                        </>
                      </Grid>

                      {/* Sellable client column */}
                      {/* <Grid item xs={12} md={6}>
												{props.priceSummaryView && props.orderType && props.orderType === "ShiftSubscription" ? (
													<>
														<span>{t("CLIENT")}: </span>
														<SellableClientColumn
															{...item}
															orderType={props.orderType}
															providerType={props.providerType}
															t={props.t}
															priceSummaryView={props.priceSummaryView}
															orderCustomer={props.orderCustomer}
															tenantData={props.tenantData}
															clearCustomer={props.clearCustomer}
															editCustomer={props.editCustomer}
															updateLineItemClient={props.updateLineItemClient}
														/>
													</>
												) : null}
											</Grid> */}
                    </Grid>
                    <div className={classes.subscriptionDetails}>
                      {item.parentSubscriptionId &&
                        props.orderTypeDescription && (
                          <p
                            style={{ margin: 0 }}
                          >{`${props.orderTypeDescription} Subscription for ${item.parentSubscriptionName ?? ""} (Subscription Id: ${item.parentSubscriptionId ?? ""})`}</p>
                        )}
                    </div>
                    <div className={classes.includedItemsTable}>
                      <TableContainer>
                        <Table className="newGlobalTable roundCorners">
                          <TableHead>
                            <TableRow>
                              <TableCell
                                colSpan={
                                  props.providerType !== "SOLUTION_PROVIDER"
                                    ? 1
                                    : 4
                                }
                              >
                                {props.t("ITEM_DESCRIPTION")}
                              </TableCell>
                              {props.providerType !== "SOLUTION_PROVIDER" && (
                                <>
                                  <TableCell
                                    style={{ width: "120px" }}
                                    align="right"
                                  >
                                    {props.t("QUANTITY")}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "200px" }}
                                    align="right"
                                  >
                                    {props.t("UNIT_PRICE")}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "200px" }}
                                    align="right"
                                  >
                                    {props.t("TOTAL_PRICE")}
                                  </TableCell>
                                </>
                              )}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {item.associatedItems.map(
                              (comp, ind) =>
                                checkFulfillable(comp.fulfillable) &&
                                comp.customerViewable && (
                                  <ItemComponent
                                    edit={props.edit}
                                    {...comp}
                                    key={ind}
                                    quantity={item.quantity}
                                    compQuantity={comp.quantity}
                                    orderStatus={props.orderStatus}
                                    solutionIndex={index}
                                    quantityModifiable={comp.quantMod}
                                    itemType={"COMP"}
                                    compIndex={ind}
                                    getPriceTenureUOM={getPriceTenureUOM}
                                    orderType={props.orderType}
                                    editQuantity={props.edit.quantity}
                                    changeQuantity={props.changeQuantity}
                                    olution={item.solution}
                                    remove={props.remove}
                                    oldOrder={false}
                                    providerType={props.providerType}
                                    t={props.t}
                                    priceSummaryView={props.priceSummaryView}
                                    toggleInventoryDialog={
                                      toggleInventoryDialog
                                    }
                                    // classess={classess}
                                    openProductSpecification={
                                      props.openProductSpecification
                                    }
                                    solutionData={item}
                                  />
                                ),
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </Card>
                </React.Fragment>
              ))}
            </Grid>
            {/* Totals */}
            <Grid
              item
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <Grid container spacing={1}>
                {props.providerType !== "SOLUTION_PROVIDER" &&
                  props.userPerms.includes("CUMULATOR_PROMO_ADMIN") && (
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <Card
                        variant="outlined"
                        className={"roundCorners " + classes.totalsCard}
                      >
                        <b style={{ marginBottom: "1rem", display: "block" }}>
                          {t("DISCOUNT_SUMMARY")}
                        </b>
                        {/* <Grid item xs={12}>
												<b>
													{(props.solutionList && props.solutionList.length > 0) &&
														currencyFormatter(props.orderDiscount)
													}
												</b>
											</Grid> */}
                        {props.orderTotalDiscount &&
                          props.orderTotalDiscount.totalDepositDiscount && (
                            <Grid
                              item
                              justifyContent="space-between"
                              style={{ padding: "4px", paddingLeft: 0 }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("DUE_NOW")}{" "}
                              <b>
                                {currencyFormatter(
                                  props.orderTotalDiscount.totalDepositDiscount,
                                )}
                              </b>
                            </Grid>
                          )}
                        {props.orderTotalDiscount &&
                          props.orderTotalDiscount.totalOTCDiscount && (
                            <Grid
                              item
                              justifyContent="space-between"
                              style={{ padding: "4px", paddingLeft: 0 }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("DUE_AT_INSTALLATION")}{" "}
                              <b>
                                {currencyFormatter(
                                  props.orderTotalDiscount.totalOTCDiscount,
                                )}
                              </b>
                            </Grid>
                          )}
                        {props.orderTotalDiscount &&
                          props.orderTotalDiscount.totalRecurringDiscount && (
                            <Grid
                              item
                              justifyContent="space-between"
                              style={{ padding: "4px", paddingLeft: 0 }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("RECURRING_CHARGES")}{" "}
                              <b>
                                {currencyFormatter(
                                  props.orderTotalDiscount
                                    .totalRecurringDiscount,
                                )}
                              </b>
                            </Grid>
                          )}
                        {props.orderTotalDiscount &&
                          props.orderTotalDiscount.totalCancelDiscount && (
                            <Grid
                              item
                              justifyContent="space-between"
                              style={{ padding: "4px", paddingLeft: 0 }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("CANCELLATION_PRICE")}{" "}
                              <b>
                                {currencyFormatter(
                                  props.orderTotalDiscount.totalCancelDiscount,
                                )}
                              </b>
                            </Grid>
                          )}
                        {props.orderTotalDiscount &&
                          props.orderTotalDiscount.totalShiftDiscount && (
                            <Grid
                              item
                              justifyContent="space-between"
                              style={{ padding: "4px", paddingLeft: 0 }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("SHIFT_PRICE")}{" "}
                              <b>
                                {currencyFormatter(
                                  props.orderTotalDiscount.totalShiftDiscount,
                                )}
                              </b>
                            </Grid>
                          )}
                        {props.orderTotalDiscount &&
                          props.orderTotalDiscount.totalUsagesDiscount && (
                            <Grid
                              item
                              justifyContent="space-between"
                              style={{ padding: "4px", paddingLeft: 0 }}
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("USAGE_CHARGE")}{" "}
                              <b>
                                {currencyFormatter(
                                  props.orderTotalDiscount.totalUsagesDiscount,
                                )}
                              </b>
                            </Grid>
                          )}
                      </Card>
                    </Grid>
                  )}
                {props.providerType !== "SOLUTION_PROVIDER" && (
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <Card
                      variant="outlined"
                      className={"roundCorners " + classes.totalsCard}
                    >
                      <b>{t("TOTAL_SUMMARY")}</b>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          justifyContent="space-between"
                          size={{
                            xs: 12,
                          }}
                        >
                          {t("DUE_NOW")}{" "}
                          <b>
                            {props.solutionList &&
                              props.solutionList.length > 0 &&
                              currencyFormatter(priceDueNow)}
                          </b>
                        </Grid>
                        <Grid
                          item
                          justifyContent="space-between"
                          size={{
                            xs: 12,
                          }}
                        >
                          {t("DUE_AT_INSTALLATION")}{" "}
                          <b>
                            {props.solutionList &&
                              props.solutionList.length > 0 &&
                              currencyFormatter(priceDueAtInstallation)}
                          </b>
                        </Grid>
                        {priceNTCtotal
                          .slice()
                          .sort((chargeA, chargeB) => {
                            const termUOMOrder = [
                              "TF_hr",
                              "TF_day",
                              "TF_wk",
                              "TF_mon",
                              "TF_yr",
                            ];
                            const indexA = termUOMOrder.indexOf(
                              chargeA.tenureUom,
                            );
                            const indexB = termUOMOrder.indexOf(
                              chargeB.tenureUom,
                            );
                            return indexA - indexB;
                          })
                          .map((charge, index) => {
                            const { key, termPeriod, tenureUom, price } =
                              charge;
                            const displayText =
                              termPeriod > 1
                                ? `${t("NTC_CHARGES")} (per ${getPriceTenureUOM(tenureUom)} for ${termPeriod} ${getPriceTenureUOM(tenureUom)}s)`
                                : `${t("NTC_CHARGES")} (per ${getPriceTenureUOM(tenureUom)} for ${termPeriod} ${getPriceTenureUOM(tenureUom)})`;
                            return (
                              price > 0 && (
                                <Grid
                                  item
                                  key={index}
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <span>{displayText}</span>
                                  <b>
                                    {props.solutionList &&
                                      props.solutionList.length > 0 &&
                                      currencyFormatter(price)}
                                  </b>
                                </Grid>
                              )
                            );
                          })}
                        {priceRecurringChargeTotal
                          .slice()
                          .sort((chargeA, chargeB) => {
                            const termUOMOrder = [
                              "TF_hr",
                              "TF_day",
                              "TF_wk",
                              "TF_mon",
                              "TF_yr",
                            ];
                            const indexA = termUOMOrder.indexOf(
                              chargeA.tenureUom,
                            );
                            const indexB = termUOMOrder.indexOf(
                              chargeB.tenureUom,
                            );
                            return indexA - indexB;
                          })
                          .map((charge, index) => {
                            const { key, termPeriod, tenureUom, price } =
                              charge;
                            const displayText =
                              termPeriod > 1
                                ? `${t("RECURRING_CHARGES")} (per ${termPeriod} ${getPriceTenureUOM(tenureUom)}s)`
                                : `${t("RECURRING_CHARGES")} (per ${getPriceTenureUOM(tenureUom)})`;

                            return (
                              price > 0 && (
                                <Grid
                                  item
                                  key={index}
                                  justifyContent="space-between"
                                  size={{
                                    xs: 12,
                                  }}
                                >
                                  <span>{displayText}</span>
                                  <b>
                                    {props.solutionList &&
                                      props.solutionList.length > 0 &&
                                      currencyFormatter(price)}
                                  </b>
                                </Grid>
                              )
                            );
                          })}
                        {(props.orderType === "CancelSubscription" ||
                          props.orderType === "TerminateSubscription") && (
                            <>
                              <Grid
                                item
                                justifyContent="space-between"
                                size={{
                                  xs: 12,
                                }}
                              >
                                {t("CANCELLATION_PRICE")}{" "}
                                <b>
                                  {props.solutionList &&
                                    props.solutionList.length > 0 &&
                                    currencyFormatter(cancellationPriceTotal)}
                                </b>
                              </Grid>
                            </>
                          )}
                        {props.orderType === "ShiftSubscription" && (
                          <>
                            <Grid
                              item
                              justifyContent="space-between"
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("SHIFT_PRICE")}{" "}
                              <b>
                                {props.solutionList &&
                                  props.solutionList.length > 0 &&
                                  currencyFormatter(shiftPriceTotal)}
                              </b>
                            </Grid>
                          </>
                        )}
                        {props.orderType === "SuspendSubscription" && (
                          <>
                            <Grid
                              item
                              justifyContent="space-between"
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("SUSPENSION_PRICE")}{" "}
                              <b>
                                {props.solutionList &&
                                  props.solutionList.length > 0 &&
                                  currencyFormatter(suspendPriceTotal)}
                              </b>
                            </Grid>
                          </>
                        )}
                        {props.orderType === "ResumeSubscription" && (
                          <>
                            <Grid
                              item
                              justifyContent="space-between"
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("REACTIVATION_PRICE")}{" "}
                              <b>
                                {props.solutionList &&
                                  props.solutionList.length > 0 &&
                                  currencyFormatter(resumePriceTotal)}
                              </b>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Card>
                  </Grid>
                )}
                {/* notes */}
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <Card
                    variant="outlined"
                    className={"roundCorners " + classes.totalsCard}
                  >
                    <b>{t("NOTES")}</b>
                    <>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          style={{ marginTop: "0px" }}
                          size={{
                            xs: 12,
                          }}
                        >
                          {props.solutionList &&
                            props.solutionList.length > 0 && (
                              // props.status !== "Order Fulfilled" &&
                              <>
                                <div
                                  style={{
                                    display: "block",
                                    marginTop: "0px",
                                    width: "100%",
                                  }}
                                >
                                  <Input
                                    size={"small"}
                                    name={"notes"}
                                    variant={"outlined"}
                                    // placeholder={this.props.t("NOTES")}
                                    //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                    value={props.notes}
                                    onChange={props.changeNotes}
                                    //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                    inputProps={{
                                      multiline: true,
                                      rows: 5,
                                      cols: 10,
                                      disabled: false,
                                    }}
                                  />
                                  <div
                                    style={{
                                      display: "block",
                                      marginTop: "15px",
                                      width: "100%",
                                      textAlign: "right",
                                    }}
                                  >
                                    <Button
                                      onClick={() => {
                                        props.confirmNote(true);
                                      }}
                                      disabled={!props.userPerms.includes("ORDERMGR_UPDATE") || !props.userPerms.includes("ORDERMGR_ADMIN") || !props.userPerms.includes("ORDERMGR_CREATE")}
                                    >
                                      {t("ADD_NOTE")}
                                    </Button>
                                  </div>
                                </div>
                              </>
                            )}
                        </Grid>
                      </Grid>
                      {props.note && props.note.length > 0 ? (
                        <>
                          <Grid container spacing={1}>
                            {props.note.map((item) => (
                              <Grid
                                item
                                className={
                                  "roundCorners borderOutline " +
                                  classes.cartItemContainer
                                }
                                style={{ marginBottom: ".5rem" }}
                                size={{
                                  xs: 12,
                                }}
                              >
                                <div
                                  style={{
                                    padding: "0rem 1rem",
                                    display: "initial",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  {item.text.length > 150 ? (
                                    <>
                                      {item.text.substring(0, 150) + "..."}{" "}
                                      <u
                                        style={{
                                          cursor: "pointer",
                                          fontStyle: "italic",
                                        }}
                                        onClick={() => showFullNote(item)}
                                      >
                                        {t("READ_MORE")}
                                      </u>
                                    </>
                                  ) : (
                                    item.text
                                  )}
                                </div>
                                {/* <div style={{ fontStyle: "italic", fontWeight: "bold", padding: "0rem 1rem" }}>{item.author}</div> */}
                                <div
                                  style={{
                                    fontStyle: "italic",
                                    fontWeight: "bold",
                                    padding: "0rem 1rem",
                                  }}
                                >
                                  {item.author} <br />
                                  {item.dateTime &&
                                    formatDate(item.dateTime)}
                                </div>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      ) : (
                        props.status === "Order Fulfilled" && (
                          <>
                            <div style={{ marginTop: "1rem" }}>
                              {props.t("NO_DATA_AVAILABLE")}
                            </div>
                          </>
                        )
                      )}
                    </>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          //priceSummary view is false
          <></>
        )}
      </Grid>
      {/* Dialog to show all notes */}
      <Dialog
        open={allNotesOpen}
        PaperComponent={DraggableDialogPaper}
        onClose={handleCloseAllNotes}
        maxWidth="md"
        fullWidth={true}
      // PaperProps={{
      // 	className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {t("ALL_NOTES")}
            </span>
            <Tooltip
              title={t("CLOSE")}
              id="show-all-notes-dialog"
              style={{ cursor: "move" }}
            >
              <IconButton
                onTouchStart={handleCloseAllNotes}
                onClick={handleCloseAllNotes}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {props.note && props.note.length > 0 ? (
              <>
                <Grid container spacing={1}>
                  {props.note.map((item) => (
                    <Grid
                      item
                      className={
                        "roundCorners borderOutline " +
                        classes.cartItemContainer
                      }
                      style={{ marginBottom: ".5rem" }}
                      size={{
                        xs: 12,
                      }}
                    >
                      <div
                        style={{
                          padding: "0rem 1rem",
                          display: "initial",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {item.text.length > 150 ? (
                          <>
                            {item.text.substring(0, 150) + "..."}{" "}
                            <u
                              style={{ cursor: "pointer", fontStyle: "italic" }}
                              onClick={() => showFullNote(item)}
                            >
                              {t("READ_MORE")}
                            </u>
                          </>
                        ) : (
                          item.text
                        )}
                      </div>
                      {/* <div style={{ fontStyle: "italic", fontWeight: "bold", padding: "0rem 1rem" }}>{item.author}</div> */}
                      <div
                        style={{
                          fontStyle: "italic",
                          fontWeight: "bold",
                          padding: "0rem 1rem",
                        }}
                      >
                        {item.author} <br />
                        {item.dateTime && formatDate(item.dateTime)}
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </>
            ) : (
              props.status === "Order Fulfilled" && (
                <>
                  <div style={{ marginTop: "1rem" }}>
                    {props.t("NO_DATA_AVAILABLE")}
                  </div>
                </>
              )
            )}
          </Grid>
        </DialogContent>
      </Dialog>
      {/* old UI for when priceSummary is false */}
      {props.priceSummaryView ? (
        <></>
      ) : (
        <Card variant="outlined" className={"roundCorners"}>
          <TableContainer>
            <Table className={"newGlobalTable"}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: "40px" }}>
                    {t("QUANTITY_SHORT")}
                  </TableCell>
                  <TableCell colSpan={2}>{t("ITEM")}</TableCell>
                  {/* {props.loggedInUserType !== 'ECOMMERCE_CUSTOMER' &&
								<TableCell >{t('DISCOUNT')} %</TableCell>
							} */}
                  <TableCell></TableCell>
                  {props.orderStatus === "ORDER_COMPLETED" ? (
                    <TableCell>{t("BILLING_REF")} #</TableCell>
                  ) : null}
                  <TableCell>{t("CLIENT")}</TableCell>
                  {props.providerType === "SALES_CHNL_PROVIDER" ? (
                    <>
                      <Tooltip title={t("TODAY_COST_TITLE")}>
                        <TableCell align="right">{t("TODAY_COST")}</TableCell>
                      </Tooltip>
                      <Tooltip title={t("RECURRING_COST_TITLE")}>
                        <TableCell align="right" style={{ paddingRight: 10 }}>
                          {t("RECURRING_COST")}
                        </TableCell>
                      </Tooltip>
                    </>
                  ) : (
                    <>
                      <TableCell>&nbsp;</TableCell>
                      <TableCell>&nbsp;</TableCell>
                    </>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {props.solutionList.map((item, index) =>
                  props.tenantId ? (
                    item.tenantId === props.tenantId && item.sellable ? (
                      <React.Fragment></React.Fragment>
                    ) : (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            {/* Start: Packaged Solution info */}
                            {/* {props.edit.item ?
												<button
													onClick={() => { props.remove(index, "SOL") }}
													className={classes.button}
												>
													Remove
												</button>
												: null
											}
											{item.solution ?
												props.edit.quantity ?
													<input
														className={classes.quantityInput}
														type="number"
														min="1"
														step="1"
														value={item.quantity}
														onChange={(e) => { props.changeQuantity(e.target.value, index, "SOL"); item.discount && props.changeDiscount(item.discount, index, "SOL") }}
													/>
													:
													<span className={classes.roItemQuantity}>{item.quantity}</span>
												: null
											} */}
                            <div className={classes.compQtyLabel}>
                              {props.edit.quantity ? (
                                <Input
                                  className={classes.quantityInput}
                                  type="number"
                                  min="1"
                                  step="1"
                                  value={item.quantity}
                                  onChange={(e) => {
                                    props.changeQuantity(
                                      e.target.value,
                                      index,
                                      "SOL",
                                    );
                                    item.discount &&
                                      props.changeDiscount(
                                        item.discount,
                                        index,
                                        "SOL",
                                      );
                                  }}
                                  style={{ background: "#fff" }}
                                />
                              ) : (
                                <b>{item.quantity}</b>
                              )}
                            </div>
                            {/* End: Packaged Solution info */}
                          </TableCell>
                          <TableCell colSpan={2}><Link target="_blank" to={`/viewProduct/${item.id}?type=myOfferings`} style={{ color: 'inherit' }}>{item.name}</Link></TableCell>
                          {/* {props.loggedInUserType !== 'ECOMMERCE_CUSTOMER' &&
											<TableCell>
												<Input
													className={classes.compQtyCell}
													type="number"
													min="0.00"
													step="0.01"
													max="100.00"
													presicion={2}
													name="discount"
													value={item.discount}
													// placeholder='0'
													disabled={props.disabledDiscount}
													onChange={(e) => { e.target.value <= 100 && props.changeDiscount(e.target.value, index, "SOL") }}
													style={{ background: '#fff' }}
												/>
											</TableCell>
										} */}
                          <TableCell></TableCell>
                          {props.orderStatus === "ORDER_COMPLETED" ? (
                            <TableCell align="right"></TableCell>
                          ) : null}
                          {props.providerType === "SALES_CHNL_PROVIDER" ? (
                            <>
                              <TableCell align="right"></TableCell>
                              <TableCell align="right"></TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell>&nbsp;</TableCell>
                              <TableCell>&nbsp;</TableCell>
                            </>
                          )}
                          <TableCell>&nbsp;</TableCell>
                        </TableRow>
                        {/* Set solution plans */}
                        {/* {item.solution ?
										<ItemComponent edit={props.edit} dontShowZero={true} {...item.solution} quantity={item.quantity} orderStatus={props.orderStatus} loggedInUserType={props.loggedInUserType} />
										: null
									} */}
                        {/* Fetch all components */}

                        {item.associatedItems.map(
                          (comp, ind) =>
                            checkFulfillable(comp.fulfillable) &&
                            comp.customerViewable && (
                              <ItemComponentOld
                                edit={props.edit}
                                {...comp}
                                key={ind}
                                quantity={item.quantity}
                                compQuantity={comp.quantity}
                                orderStatus={props.orderStatus}
                                solutionIndex={index}
                                quantityModifiable={comp.quantMod}
                                itemType={"COMP"}
                                compIndex={ind}
                                getPriceTenureUOM={getPriceTenureUOM}
                                orderType={props.orderType}
                                editQuantity={props.edit.quantity}
                                changeQuantity={props.changeQuantity}
                                solution={item.solution}
                                remove={props.remove}
                                oldOrder={false}
                                providerType={props.providerType}
                                t={props.t}
                                priceSummaryView={props.priceSummaryView}
                                orderCustomer={props.orderCustomer}
                                tenantData={props.tenantData}
                                clearCustomer={props.clearCustomer}
                                editCustomer={props.editCustomer}
                                updateLineItemClient={
                                  props.updateLineItemClient
                                }
                                toggleInventoryDialog={toggleInventoryDialog}
                              />
                            ),
                        )}
                        {/* {props.componentList.length > 0 &&
										props.componentList.map((component) =>
											item[component.name] ? item[component.name].map((comp, ind) =>
												<ItemComponent edit={props.edit} {...comp} key={ind} quantity={item.quantity} compQuantity={comp.quantity} orderStatus={props.orderStatus} solutionIndex={index}
													quantityModifiable={comp.quantMod} itemType={"COMP"} compType={component.name} compIndex={ind}
													editQuantity={props.edit.quantity} changeQuantity={props.changeQuantity} solution={item.solution} remove={props.remove}
													loggedInUserType={props.loggedInUserType} />
											) : null
										)
									} */}
                        {/* Set services */}
                        {/* {item.services ? item.services.map((comp, ind) =>
											<ItemComponent edit={props.edit} {...comp} key={ind} quantity={item.quantity} orderStatus={props.orderStatus} solution={item.solution} />
										) : null} */}
                      </React.Fragment>
                    )
                  ) : item.sellable ? (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell>
                          {/* Start: Packaged Solution info */}
                          {props.edit.item ? (
                            <button
                              onClick={() => {
                                props.remove(index, "SOL");
                              }}
                              className={classes.button}
                            >
                              Remove
                            </button>
                          ) : null}
                          {props.edit.quantity ? (
                            <Input
                              className={classes.quantityInput}
                              type="number"
                              min="1"
                              step="1"
                              value={item.quantity}
                              onChange={(e) => {
                                props.changeQuantity(
                                  e.target.value,
                                  index,
                                  "SOL",
                                );
                              }}
                              style={{ background: "#fff" }}
                            />
                          ) : (
                            <b>{item.quantity}</b>
                          )}
                          {/* End: Packaged Solution info */}
                        </TableCell>
                        <TableCell colSpan={2}>
                          <div style={{ display: "inline-flex" }}>
                            {item.name}
                            {item.associatedItems &&
                              item.associatedItems.length > 0 &&
                              item.associatedItems[0].inventoryDetail &&
                              item.associatedItems[0].inventoryDetail.length >
                              0 && (
                                <span
                                  style={{
                                    position: "relative",
                                    marginLeft: "10px",
                                    top: "-2px",
                                  }}
                                >
                                  <Tooltip
                                    title={t("VIEW_INVENTORY")}
                                    onClick={(e) => {
                                      toggleInventoryDialog(
                                        item.name,
                                        item.associatedItems[0].inventoryDetail,
                                      );
                                    }}
                                  >
                                    {/* <VisibilityIcon /> */}
                                    <IconButton className="buttonSecondary">
                                      <ViewIconNew />
                                    </IconButton>
                                  </Tooltip>
                                </span>
                              )}
                          </div>
                        </TableCell>
                        {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                          props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                            // <TableCell>
                            //     {item.discount}
                            // </TableCell>
                            <TableCell></TableCell>
                          )}
                        {props.orderStatus === "ORDER_COMPLETED" && (
                          <TableCell>{props.pcoSeqNum}</TableCell>
                        )}
                        <SellableClientColumn
                          {...item}
                          orderType={props.orderType}
                          providerType={props.providerType}
                          t={props.t}
                          priceSummaryView={props.priceSummaryView}
                          orderCustomer={props.orderCustomer}
                          tenantData={props.tenantData}
                          clearCustomer={props.clearCustomer}
                          editCustomer={props.editCustomer}
                          updateLineItemClient={props.updateLineItemClient}
                        />
                        {item.associatedItems.map((comp, ind) =>
                          props.providerType === "SALES_CHNL_PROVIDER" ? (
                            <>
                              <TableCell align="right">
                                {!comp.price.recurringPrice &&
                                  comp.price.purchasePrice
                                  ? parseInt(comp.price.purchasePrice) === 0 &&
                                    comp.dontShowZero
                                    ? ""
                                    : currencyFormatter(
                                      (
                                        Math.round(
                                          comp.price.purchasePrice *
                                          (comp.oldOrder
                                            ? comp.quantity
                                            : comp.quantity *
                                            item.quantity) *
                                          100,
                                        ) / 100
                                      ).toFixed(2),
                                    )
                                  : currencyFormatter("", false) + "0.00"}
                              </TableCell>
                              <TableCell align="right">
                                {comp.price.recurringPrice
                                  ? parseInt(
                                    comp.price.recurringPrice.price,
                                  ) === 0 && comp.dontShowZero
                                    ? ""
                                    : currencyFormatter(
                                      (
                                        Math.round(
                                          comp.price.recurringPrice.price *
                                          (comp.oldOrder
                                            ? comp.quantity
                                            : comp.quantity *
                                            item.quantity) *
                                          100,
                                        ) / 100
                                      ).toFixed(2),
                                    )
                                  : currencyFormatter("", false) + "0.00"}
                              </TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell>&nbsp;</TableCell>
                              <TableCell>&nbsp;</TableCell>
                            </>
                          ),
                        )}
                      </TableRow>
                      {/* {item.associatedItems && item.associatedItems.length > 0 && item.associatedItems[0].inventoryDetail && item.associatedItems[0].inventoryDetail.length > 0 &&
												<TableRow>
													<TableCell colSpan={7}>
														<SerializedItemNumbers data={item.associatedItems[0].inventoryDetail} t={t} />
													</TableCell>
												</TableRow>
											} */}
                      {item.associatedItems &&
                        item.associatedItems.length > 0 &&
                        item.associatedItems[0].bom &&
                        item.associatedItems[0].bom.length > 0 && (
                          <TableRow>
                            <TableCell colSpan={7}>
                              <Collapse in={true}>
                                {item.associatedItems[0].bom
                                  .sort((a, b) =>
                                    a && b
                                      ? a.displaySequence - b.displaySequence
                                      : 0,
                                  )
                                  .map((bom, index) => (
                                    <div
                                      key={bom.id}
                                      style={{
                                        marginLeft: "93px",
                                        marginRight: "36px",
                                      }}
                                    >
                                      <BomItem
                                        data={bom}
                                        index={index}
                                        t={t}
                                        parentItem={item.associatedItems[0]}
                                        level={1}
                                        toggleInventoryDialog={
                                          toggleInventoryDialog
                                        }
                                      />
                                    </div>
                                  ))}
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell>
                          {/* Start: Packaged Solution info */}
                          {props.edit.item ? (
                            <button
                              onClick={() => {
                                props.remove(index, "SOL");
                              }}
                              className={classes.button}
                            >
                              Remove
                            </button>
                          ) : null}
                          {props.edit.quantity ? (
                            <Input
                              className={classes.quantityInput}
                              type="number"
                              min="1"
                              step="1"
                              value={item.quantity}
                              onChange={(e) => {
                                props.changeQuantity(
                                  e.target.value,
                                  index,
                                  "SOL",
                                );
                              }}
                              style={{ background: "#fff" }}
                            />
                          ) : (
                            <b>{item.quantity}</b>
                          )}
                          {/* End: Packaged Solution info */}
                        </TableCell>
                        <TableCell colSpan={2}>{item.name}</TableCell>
                        {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                          props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                            // <TableCell>
                            //     {item.discount}
                            // </TableCell>
                            <TableCell></TableCell>
                          )}
                        {props.orderStatus === "ORDER_COMPLETED" ? (
                          <TableCell align="right"></TableCell>
                        ) : null}
                        <SellableClientColumn
                          {...item}
                          orderType={props.orderType}
                          providerType={props.providerType}
                          t={props.t}
                          priceSummaryView={props.priceSummaryView}
                          orderCustomer={props.orderCustomer}
                          tenantData={props.tenantData}
                          clearCustomer={props.clearCustomer}
                          editCustomer={props.editCustomer}
                          updateLineItemClient={props.updateLineItemClient}
                        />
                        {props.providerType === "SALES_CHNL_PROVIDER" ? (
                          <>
                            <TableCell align="right"></TableCell>
                            <TableCell align="right"></TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell>&nbsp;</TableCell>
                            <TableCell>&nbsp;</TableCell>
                          </>
                        )}
                      </TableRow>
                      {/* Set solution plans */}
                      {/* {item.solution ?
										<ItemComponent edit={props.edit} dontShowZero={true} {...item.solution} quantity={item.quantity} orderStatus={props.orderStatus} loggedInUserType={props.loggedInUserType} />
										: null
									} */}
                      {/* Fetch all components */}
                      {item.associatedItems.map(
                        (comp, ind) =>
                          checkFulfillable(comp.fulfillable) &&
                          comp.customerViewable && (
                            <ItemComponentOld
                              edit={props.edit}
                              {...comp}
                              key={ind}
                              quantity={item.quantity}
                              compQuantity={comp.quantity}
                              orderStatus={props.orderStatus}
                              solutionIndex={index}
                              quantityModifiable={comp.quantMod}
                              itemType={"COMP"}
                              compIndex={ind}
                              getPriceTenureUOM={getPriceTenureUOM}
                              orderType={props.orderType}
                              editQuantity={props.edit.quantity}
                              changeQuantity={props.changeQuantity}
                              solution={item.solution}
                              remove={props.remove}
                              oldOrder={false}
                              providerType={props.providerType}
                              t={props.t}
                              priceSummaryView={props.priceSummaryView}
                              orderCustomer={props.orderCustomer}
                              tenantData={props.tenantData}
                              clearCustomer={props.clearCustomer}
                              editCustomer={props.editCustomer}
                              updateLineItemClient={props.updateLineItemClient}
                              toggleInventoryDialog={toggleInventoryDialog}
                            />
                          ),
                      )}
                      {/* Show volume discount */}
                      {item.discountDetails && item.discountDetails.value && (
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell>
                            <span
                              style={{
                                display: "block",
                                fontWeight: "bold",
                                fontStyle: "italic",
                              }}
                            >
                              {item.discountDetails &&
                                item.discountDetails.value}
                              % {t("DISCOUNT")}
                            </span>
                          </TableCell>
                          {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                            props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                              <TableCell></TableCell>
                            )}
                          {props.orderStatus === "ORDER_COMPLETED" ? (
                            <TableCell align="right"></TableCell>
                          ) : null}
                          <TableCell>&nbsp;</TableCell>
                          {props.providerType === "SALES_CHNL_PROVIDER" ? (
                            <>
                              <TableCell align="right">
                                -{" "}
                                {currencyFormatter(
                                  item.discountDetails &&
                                  item.discountDetails.nrDiscount,
                                )}
                              </TableCell>
                              <TableCell align="right">
                                -{" "}
                                {currencyFormatter(
                                  item.discountDetails &&
                                  item.discountDetails.rcDiscount,
                                )}
                              </TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell>&nbsp;</TableCell>
                              <TableCell>&nbsp;</TableCell>
                            </>
                          )}
                        </TableRow>
                      )}
                      {/* Set services */}
                      {/* {item.services ? item.services.map((comp, ind) =>
											<ItemComponent edit={props.edit} {...comp} key={ind} quantity={item.quantity} orderStatus={props.orderStatus} solution={item.solution} />
										) : null} */}
                    </React.Fragment>
                  ),
                )}
                {/* Accessories block */}
                {/* <TableRow className={classes.itemSeperator}>
							<TableCell></TableCell>
							<TableCell >{props.t('ACCESSORIES')}</TableCell>
							{props.loggedInUserType !== 'ECOMMERCE_CUSTOMER' &&
								<TableCell></TableCell>
							}
							{(props.orderStatus === 'ORDER_COMPLETED') ?
								<TableCell align="right"></TableCell>
								: null
							}
							{props.providerType == 'SALES_CHNL_PROVIDER' &&
								<>
									<TableCell align="right"></TableCell>
									<TableCell align="right"></TableCell>
								</>
							}
						</TableRow>
						{props.accessoryList.map((item, index) =>
							props.tenantId ?
								(
									item.tenantId === props.tenantId &&
									<React.Fragment key={index}>
										<AccComponent
											{...item}
											key={index}
											index={index}
											changeQuantity={(value) => { props.changeQuantity(value, index, "ACC") }}
											remove={() => { props.remove(index, "ACC") }}
											editQuantity={props.edit.quantity}
											editItem={props.edit.item}
											editPrice={props.edit.price}
											changeAccPrice={props.changeAccPrice}
											orderStatus={props.orderStatus}
										/>
									</React.Fragment>
								)
								:
								<React.Fragment key={index}>
									<AccComponent
										{...item}
										key={index}
										index={index}
										changeQuantity={(value) => { props.changeQuantity(value, index, "ACC") }}
										remove={() => { props.remove(index, "ACC") }}
										editQuantity={props.edit.quantity}
										editItem={props.edit.item}
										editPrice={props.edit.price}
										changeAccPrice={props.changeAccPrice}
										orderStatus={props.orderStatus}
									/>
								</React.Fragment>
						)} */}
                {props.providerType === "SALES_CHNL_PROVIDER" && (
                  <>
                    <TableRow className={classes.totalCostRow}>
                      <TableCell></TableCell>
                      {props.orderStatus === "ORDER_COMPLETED" ? (
                        <TableCell
                          colSpan={
                            props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                              props.loggedInUserType !== "ECOMMERCE_ADMIN"
                              ? 4
                              : 3
                          }
                        >
                          {t("TOTALS")}
                        </TableCell>
                      ) : (
                        <TableCell
                          colSpan={
                            props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                              props.loggedInUserType !== "ECOMMERCE_ADMIN"
                              ? 3
                              : 2
                          }
                        >
                          {t("TOTALS")}
                        </TableCell>
                      )}
                      {(props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                        props.loggedInUserType === "ECOMMERCE_ADMIN") && (
                          <TableCell></TableCell>
                        )}
                      <TableCell></TableCell>
                      <TableCell align="right" className="totalCost">
                        {currencyFormatter(
                          (Math.round(nowTotal * 100) / 100).toFixed(2),
                        )}
                      </TableCell>
                      <TableCell
                        align="right"
                        className="monthlyCost"
                        style={{ paddingRight: 10 }}
                      >
                        {currencyFormatter(
                          (Math.round(recTotal * 100) / 100).toFixed(2),
                        )}
                      </TableCell>
                    </TableRow>

                    {/* Discounted Total Row  */}
                    {totalDiscount > 0 &&
                      (nowDiscountedPrice > 0 || recDiscountedPrice > 0) && (
                        <>
                          <TableRow className={classes.totalCostRow}>
                            <TableCell></TableCell>
                            {props.orderStatus === "ORDER_COMPLETED" ? (
                              <TableCell colSpan={4}>
                                {t("TOTAL_DISCOUNT")}
                              </TableCell>
                            ) : (
                              <TableCell colSpan={3}>
                                {t("TOTAL_DISCOUNT")}
                              </TableCell>
                            )}
                            {nowDiscountedPrice && (
                              <TableCell align="right" className="totalCost">
                                {currencyFormatter(
                                  (
                                    Math.round(nowTotal * 100) / 100 -
                                    nowDiscountedPrice
                                  ).toFixed(2),
                                )}
                              </TableCell>
                            )}
                            <TableCell align="right" className="monthlyCost">
                              {recDiscountedPrice
                                ? parseInt(recDiscountedPrice) === 0
                                  ? ""
                                  : currencyFormatter(
                                    (
                                      Math.round(recTotal * 100) / 100 -
                                      recDiscountedPrice
                                    ).toFixed(2),
                                  )
                                : currencyFormatter("", false) + "0.00"}
                            </TableCell>
                          </TableRow>
                          <TableRow className={classes.totalCostRow}>
                            <TableCell></TableCell>
                            {props.orderStatus === "ORDER_COMPLETED" ? (
                              <TableCell colSpan={4}>
                                {t("ORDER_TOTAL_AFTER_DISCOUNT")}
                              </TableCell>
                            ) : (
                              <TableCell colSpan={3}>
                                {t("ORDER_TOTAL_AFTER_DISCOUNT")}
                              </TableCell>
                            )}
                            {nowDiscountedPrice && (
                              <TableCell align="right" className="totalCost">
                                {currencyFormatter(nowDiscountedPrice)}
                              </TableCell>
                            )}
                            <TableCell align="right" className="monthlyCost">
                              {recDiscountedPrice
                                ? parseInt(recDiscountedPrice) === 0
                                  ? ""
                                  : currencyFormatter(recDiscountedPrice)
                                : currencyFormatter("", false) + "0.00"}
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}
      {inventoryDetail && inventoryDetail.show && (
        <InventoryDetails
          {...inventoryDetail}
          open={inventoryDetail.show}
          close={toggleInventoryDialog}
        />
      )}
      {showNote && (
        <ShowNoteDialog note={noteData} open={showNote} close={closeFullNote} />
      )}
    </div>
  );
};

const ItemComponent = (props) => {
  const [showHierarchy, toggleShowHierarchy] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [mode, setmode] = useState("ADD");
  const [expandBom, setExpandBom] = useState(false);
  // console.log(props)

  useEffect(() => {
    if (props.locationDetail && props.locationDetail.partyId) {
      setSelectedCustomer([props.locationDetail]);
    }
  }, []);

  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };
  const handleExpandBom = () => {
    this.setState({ expandBom: !this.state.expandBom });
  };
  const selectCustomers = (data) => {
    toggleShowHierarchy(false);
    props.updateLineItemClient(props.orderItemSeqId, data.partyId, mode);
    setmode("ADD");
  };
  const editCustomer = () => {
    setmode("MODIFY");
    toggleShowHierarchy(true);
  };
  const clearCustomer = () => {
    props.updateLineItemClient(
      props.orderItemSeqId,
      selectedCustomer[0].partyId,
      "DELETE",
    );
  };
  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else {
      return "";
    }
  };
  const handleCharacteristicsUpdate = () => { };
  const handleCloseSpecificationDialog = () => { };
  return (
    <>
      {props.priceSummaryView ? (
        <>
          <TableRow className="">
            <TableCell colSpan={3}>
              {props.compQuantity > 0 &&
                (props.editQuantity && props.quantityModifiable ? (
                  <>
                    <IconButton
                      onClick={() =>
                        props.remove(
                          props.solutionIndex,
                          props.itemType,
                          props.compType,
                          props.compIndex,
                        )
                      }
                      className="buttonSecondary"
                      style={{ marginRight: ".5rem" }}
                    >
                      <DeleteIconNew />
                    </IconButton>

                    <Input
                      className={classes.quantityInput}
                      type="number"
                      min="1"
                      step="1"
                      value={props.compQuantity}
                      onChange={(e) =>
                        props.changeQuantity(
                          e.target.value,
                          props.solutionIndex,
                          props.itemType,
                          props.compType,
                          props.compIndex,
                        )
                      }
                      style={{ background: "#fff", margin: "0 !important" }}
                    />
                  </>
                ) : props.solution ? (
                  ""
                ) : (
                  formatNumber(props.compQuantity * props.quantity)
                ))}{" "}
              x <b>{props.name ? props.name : props.productName}</b>
              {props.productSpec && props.productSpec.category && (
                <Tooltip title={props.t("PRODUCT_SPECIFICATION")}>
                  <span
                    onClick={() =>
                      props.openProductSpecification(
                        props.solutionData,
                        props.productId,
                      )
                    }
                    style={{
                      display: "inline-flex",
                      position: "relative",
                      marginLeft: "10px",
                      top: "3px",
                    }}
                  >
                    <ClipboardWithGear />
                  </span>
                </Tooltip>
              )}
            </TableCell>
            <TableCell>
              {props.orderStatus === "ORDER_COMPLETED" &&
                (props.t
                  ? `${props.t("SEQ_NUM")}: ${props.pcoSeqNum}`
                  : `${props.pcoSeqNum}`)}
            </TableCell>
          </TableRow>
          {props.providerType !== "SOLUTION_PROVIDER" &&
            (props.recurringCost?.some((charge) => Number(charge.amount) > 0) ||
              Number(props.nonRecurringCost) > 0 ||
              Number(props.depositPrice) > 0 ||
              Number(props.setupFee) > 0 ||
              Number(props.amount) > 0 ||
              Number(props.cancellationPrice) > 0 ||
              Number(props.shiftPrice) > 0 ||
              Number(props.suspendPrice) > 0 ||
              Number(props.resumePrice) > 0 ||
              props.otherPrices?.some((op) => Number(op.price) > 0)) && (
              <>
                {props.nonRecurringCost &&
                  Number(props.nonRecurringCost) > 0 ? (
                  <TableRow>
                    <TableCell>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <EnterArrow />
                        {props.t("NRC_FULL")}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(props.compQuantity * props.quantity)}
                    </TableCell>
                    <TableCell align="right">
                      {currencyFormatter(
                        Math.round(props.nonRecurringCost * 100) / 100,
                      )}
                    </TableCell>
                    <TableCell align="right">
                      <>
                        {Number(props.nonRecurringCost) === 0 &&
                          props.dontShowZero
                          ? ""
                          : currencyFormatter(
                            (
                              Math.round(
                                props.nonRecurringCost *
                                (props.oldOrder
                                  ? props.compQuantity
                                  : props.compQuantity * props.quantity) *
                                100,
                              ) / 100
                            ).toFixed(2),
                          )}
                      </>
                    </TableCell>
                  </TableRow>
                ) : null}
                {props.recurringCost &&
                  props.recurringCost.length > 0 &&
                  props.recurringCost.map((charge, index) => {
                    const { key, termPeriod, tenureUom, amount } = charge;
                    const displayText =
                      termPeriod > 1
                        ? `${props.t("RC_FULL")} (per ${termPeriod} ${getPriceTenureUOM(tenureUom)}s)`
                        : `${props.t("RC_FULL")} (per ${getPriceTenureUOM(tenureUom)})`;

                    return (
                      amount > 0 && (
                        <TableRow>
                          <TableCell>
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <EnterArrow />
                              {displayText}
                            </span>
                          </TableCell>
                          <TableCell align="right">
                            {formatNumber(props.compQuantity * props.quantity)}
                          </TableCell>
                          <TableCell align="right">
                            {currencyFormatter(Math.round(amount * 100) / 100)}
                          </TableCell>
                          <TableCell align="right">
                            {parseInt(amount) === 0 && props.dontShowZero
                              ? ""
                              : currencyFormatter(
                                (
                                  Math.round(
                                    amount *
                                    (props.oldOrder
                                      ? props.compQuantity
                                      : props.compQuantity *
                                      props.quantity) *
                                    100,
                                  ) / 100
                                ).toFixed(2),
                              )}
                          </TableCell>
                        </TableRow>
                      )
                    );
                  })}
                {!props.recurringCost && !props.nonRecurringCost && (
                  <>
                    {!props.price.recurringPrice &&
                      Number(props.amount) > 0 && (
                        <TableRow>
                          <TableCell>
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <EnterArrow />
                              {props.chargeType === "NTC"
                                ? props.chargeTerm.termPeriod > 1
                                  ? `${props.t("NTC_FULL")} (per ${getPriceTenureUOM(props.chargeTerm.termUomId)} for ${props.chargeTerm.termPeriod
                                  } ${getPriceTenureUOM(props.chargeTerm.termUomId)}s)`
                                  : `${props.t("NTC_FULL")} (per ${getPriceTenureUOM(props.chargeTerm.termUomId)} for ${props.chargeTerm.termPeriod
                                  } ${getPriceTenureUOM(props.chargeTerm.termUomId)})`
                                : props.t("NRC_FULL")}
                            </span>
                          </TableCell>
                          <TableCell align="right">
                            {formatNumber(props.compQuantity * props.quantity)}
                          </TableCell>
                          <TableCell align="right">
                            {currencyFormatter(props.amount)}
                          </TableCell>
                          <TableCell align="right">
                            {parseInt(props.amount) === 0 && props.dontShowZero
                              ? ""
                              : currencyFormatter(
                                (
                                  Math.round(
                                    (props.originalPrice ? props.originalPrice : props.amount) *
                                    (props.oldOrder
                                      ? props.compQuantity
                                      : props.compQuantity *
                                      props.quantity) *
                                    100,
                                  ) / 100
                                ).toFixed(2),
                              )}
                          </TableCell>
                        </TableRow>
                      )}
                    {props.price.recurringPrice &&
                      Number(props.price.recurringPrice.price) > 0 && (
                        <TableRow>
                          <TableCell>
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <EnterArrow />
                              {props.t("RC_FULL")}
                              {props.chargeTerm &&
                                (props.chargeTerm.termPeriod
                                  ? props.chargeTerm.termPeriod > 1
                                    ? " (" +
                                    "per " +
                                    props.chargeTerm.termPeriod +
                                    " " +
                                    getPriceTenureUOM(
                                      props.chargeTerm.termUomId,
                                    ) +
                                    "s" +
                                    ")"
                                    : " (" +
                                    "per " +
                                    getPriceTenureUOM(
                                      props.chargeTerm.termUomId,
                                    ) +
                                    ")"
                                  : "")}
                            </span>
                          </TableCell>
                          <TableCell align="right">
                            {formatNumber(props.compQuantity * props.quantity)}
                          </TableCell>
                          <TableCell align="right">
                            {currencyFormatter(props.amount)}
                          </TableCell>
                          <TableCell align="right">
                            {parseInt(props.amount) === 0 && props.dontShowZero
                              ? ""
                              : currencyFormatter(
                                (
                                  Math.round(
                                    (props.originalPrice ? props.originalPrice : props.amount) *
                                    (props.oldOrder
                                      ? props.compQuantity
                                      : props.compQuantity *
                                      props.quantity) *
                                    100,
                                  ) / 100
                                ).toFixed(2),
                              )}
                          </TableCell>
                        </TableRow>
                      )}
                  </>
                )}
                {props.depositPrice && Number(props.depositPrice) > 0 && (
                  <TableRow>
                    <TableCell>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <EnterArrow />
                        {props.t("DEPOSIT_PRICE")}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(props.compQuantity * props.quantity)}
                    </TableCell>
                    <TableCell align="right">
                      {currencyFormatter(
                        Math.round(props.depositPrice * 100) / 100,
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {parseInt(props.depositPrice) === 0 && props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.depositPrice *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </TableCell>
                  </TableRow>
                )}

                {props.setupFee && Number(props.setupFee) > 0 && (
                  <TableRow>
                    <TableCell>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <EnterArrow />
                        {props.t("SETUP_FEE")}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(props.compQuantity * props.quantity)}
                    </TableCell>
                    <TableCell align="right">
                      {currencyFormatter(
                        Math.round(props.setupFee * 100) / 100,
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {parseInt(props.setupFee) === 0 && props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.setupFee *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </TableCell>
                  </TableRow>
                )}
                {props.suspendPrice && Number(props.suspendPrice) > 0 && (
                  <TableRow>
                    <TableCell>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <EnterArrow />
                        {props.t("SUSPENSION_PRICE")}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(props.compQuantity * props.quantity)}
                    </TableCell>
                    <TableCell align="right">
                      {currencyFormatter(props.suspendPrice)}
                    </TableCell>

                    <TableCell align="right">
                      {parseInt(props.suspendPrice) === 0 && props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.suspendPrice *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </TableCell>
                  </TableRow>
                )}
                {props.resumePrice && Number(props.resumePrice) > 0 && (
                  <TableRow>
                    <TableCell>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <EnterArrow />
                        {props.t("REACTIVATION_PRICE")}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(props.compQuantity * props.quantity)}
                    </TableCell>
                    <TableCell align="right">
                      {currencyFormatter(props.resumePrice)}
                    </TableCell>

                    <TableCell align="right">
                      {parseInt(props.resumePrice) === 0 && props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.resumePrice *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </TableCell>
                  </TableRow>
                )}
                {!props.recurringCost &&
                  !props.nonRecurringCost &&
                  props.otherPrices &&
                  props.otherPrices.length > 0 &&
                  props.otherPrices.map((op, opx) =>
                    Number(op.price) > 0 &&
                      op.priceType === "CANCELLATION_PRICE" ? (
                      <>
                        {props.orderType === "CancelSubscription" ||
                          props.orderType === "TerminateSubscription" ? (
                          <TableRow key={opx}>
                            <TableCell>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <EnterArrow />
                                {props.t(op.priceType)}
                              </span>
                              {op.priceTenure !== null && op.priceTenureUOM && (
                                <span>
                                  {op.priceTenure > 1
                                    ? ` (per ${op.priceTenure} ${props.getPriceTenureUOM(op.priceTenureUOM)}s)`
                                    : ` (per ${props.getPriceTenureUOM(op.priceTenureUOM)})`}
                                </span>
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {formatNumber(props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity)}
                            </TableCell>
                            <TableCell align="right">
                              {currencyFormatter(
                                Math.round(op.price * 100) / 100,
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {parseInt(op.price) === 0 && props.dontShowZero
                                ? ""
                                : currencyFormatter(
                                  (
                                    Math.round(
                                      op.price *
                                      (props.oldOrder
                                        ? props.compQuantity
                                        : props.compQuantity *
                                        props.quantity) *
                                      100,
                                    ) / 100
                                  ).toFixed(2),
                                )}
                            </TableCell>
                          </TableRow>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <TableRow key={opx}>
                        <TableCell>
                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <EnterArrow />
                            {props.t(op.priceType)}
                          </span>
                          {op.priceTenure !== null && op.priceTenureUOM && (
                            <span>
                              {op.priceTenure > 1
                                ? ` (per ${op.priceTenure} ${props.getPriceTenureUOM(op.priceTenureUOM)}s)`
                                : ` (per ${props.getPriceTenureUOM(op.priceTenureUOM)})`}
                            </span>
                          )}
                        </TableCell>
                        <TableCell align="right">
                          {formatNumber(props.oldOrder
                            ? props.compQuantity
                            : props.compQuantity * props.quantity)}
                        </TableCell>
                        <TableCell align="right">
                          {currencyFormatter(Math.round(op.price * 100) / 100)}
                        </TableCell>
                        <TableCell align="right">
                          {parseInt(op.price) === 0 && props.dontShowZero
                            ? ""
                            : currencyFormatter(
                              (
                                Math.round(
                                  op.price *
                                  (props.oldOrder
                                    ? props.compQuantity
                                    : props.compQuantity * props.quantity) *
                                  100,
                                ) / 100
                              ).toFixed(2),
                            )}
                        </TableCell>
                      </TableRow>
                    ),
                  )}
                {/* cancellation price  */}
                {props.cancellationPrice &&
                  Number(props.cancellationPrice) > 0 && (
                    <TableRow>
                      <TableCell>
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <EnterArrow />
                          {props.t("CANCELLATION_PRICE")}
                        </span>
                      </TableCell>
                      <TableCell align="right">
                        {formatNumber(props.compQuantity * props.quantity)}
                      </TableCell>
                      <TableCell align="right">
                        {currencyFormatter(
                          Math.round(props.cancellationPrice * 100) / 100,
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {parseInt(props.cancellationPrice) === 0 &&
                          props.dontShowZero
                          ? ""
                          : currencyFormatter(
                            (
                              Math.round(
                                props.cancellationPrice *
                                (props.oldOrder
                                  ? props.compQuantity
                                  : props.compQuantity * props.quantity) *
                                100,
                              ) / 100
                            ).toFixed(2),
                          )}
                      </TableCell>
                    </TableRow>
                  )}
                {/* cancellation price  */}
                {props.shiftPrice && Number(props.shiftPrice) > 0 && (
                  <TableRow>
                    <TableCell>
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <EnterArrow />
                        {props.t("SHIFT_PRICE")}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(props.compQuantity * props.quantity)}
                    </TableCell>
                    <TableCell align="right">
                      {currencyFormatter(
                        Math.round(props.shiftPrice * 100) / 100,
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {parseInt(props.shiftPrice) === 0 && props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.shiftPrice *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
          {/* bom  */}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            props.bom &&
            props.bom.length > 0 && (
              <TableContainer>
                <Table className="newGlobalTable roundCorners">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <span>
                          <IconButton
                            onClick={handleExpandBom}
                            style={{ padding: "0px !important" }}
                          >
                            {expandBom ? (
                              <>
                                <KeyboardArrowUp fontSize="small" />
                              </>
                            ) : (
                              <>
                                <KeyboardArrowDown fontSize="small" />
                              </>
                            )}
                          </IconButton>
                          {expandBom
                            ? props.t("HIDE_BOM_ITEMS")
                            : props.t("SHOW_BOM_ITEMS")}
                        </span>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Collapse in={expandBom}>
                          {props.bom
                            .sort((a, b) =>
                              a && b
                                ? a.displaySequence - b.displaySequence
                                : 0,
                            )
                            .map((bom, index) => (
                              <React.Fragment key={bom.id}>
                                <BomItemNew
                                  data={bom}
                                  index={index}
                                  t={props.t}
                                  parentItem={props}
                                  level={1}
                                  toggleInventoryDialog={
                                    props.toggleInventoryDialog
                                  }
                                />
                              </React.Fragment>
                            ))}
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          {props.expandChar && (
            <TableRow>
              <TableCell colSpan={4}>
                <Collapse in={props.expandChar}>
                  <div className={classes.planDescription} />
                  <OfferingProductSpecCharacteristicsExistingDialog
                    t={props.t}
                    open={true}
                    productId={props.productId}
                    offeringData={props.solution}
                    productName={props.productName}
                    onClose={handleCloseSpecificationDialog}
                    componentProductCharacteristics={
                      props.productSpec ? props.productSpec : {}
                    }
                    changedCharacteristics={
                      props.characteristics ? props.characteristics : []
                    }
                    onCharacteristicsChange={handleCharacteristicsUpdate}
                    screen="checkout"
                    subScreen={"order"}
                  />
                </Collapse>
              </TableCell>
            </TableRow>
          )}
        </>
      ) : (
        <React.Fragment></React.Fragment>
      )}
    </>
  );
};

const ItemComponentOld = (props) => {
  const [showHierarchy, toggleShowHierarchy] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [mode, setmode] = useState("ADD");
  useEffect(() => {
    if (props.locationDetail && props.locationDetail.partyId) {
      setSelectedCustomer([props.locationDetail]);
    }
  }, []);
  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };
  const selectCustomers = (data) => {
    toggleShowHierarchy(false);
    props.updateLineItemClient(props.orderItemSeqId, data.partyId, mode);
    setmode("ADD");
    // if (mode === 'edit') {
    //     var tempData = {
    //         partyId: data.partyId,
    //         name: data.name
    //     }
    //     setSelectedCustomer([tempData]);
    //     props.editCustomer(props.orderItemSeqId, data.partyId)
    // } else {
    //     var tempData = {
    //         partyId: data.partyId,
    //         name: data.name
    //     }
    //     setSelectedCustomer([tempData]);
    // }
    // setmode('add');
  };
  const editCustomer = () => {
    setmode("MODIFY");
    toggleShowHierarchy(true);
  };
  const clearCustomer = () => {
    props.updateLineItemClient(
      props.orderItemSeqId,
      selectedCustomer[0].partyId,
      "DELETE",
    );
    // setSelectedCustomer([]);
    // props.clearCustomer(props.orderItemSeqId, selectedCustomer[0].partyId, 'DELETE')
  };
  const getPriceTenureUOM = (val) => {
    // console.log('getpricetemure===', val);
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else {
      return "";
    }
  };
  return (
    <>
      {props.priceSummaryView ? (
        <>
          <TableRow>
            <TableCell>&nbsp;</TableCell>
            <TableCell
              style={{
                width:
                  props.providerType === "SALES_CHNL_PROVIDER"
                    ? "auto"
                    : "40px",
              }}
              align="right"
            >
              {props.compQuantity && props.compQuantity > 0 ? (
                props.editQuantity && props.quantityModifiable ? (
                  // Check if component quantity is allowed to change
                  <React.Fragment>
                    {/* Remove packaged solution */}
                    <button
                      onClick={() => {
                        props.remove(
                          props.solutionIndex,
                          props.itemType,
                          props.compType,
                          props.compIndex,
                        );
                      }}
                      className={classes.button}
                    >
                      Remove
                    </button>
                    <Input
                      className={classes.compQtyCell}
                      type="number"
                      min="1"
                      step="1"
                      value={props.compQuantity}
                      onChange={(e) => {
                        props.changeQuantity(
                          e.target.value,
                          props.solutionIndex,
                          props.itemType,
                          props.compType,
                          props.compIndex,
                        );
                      }}
                      style={{ background: "#fff" }}
                    />
                  </React.Fragment>
                ) : (
                  // <div className={classes.compQtyLabel}>{props.solution ? "" : props.compQuantity * props.quantity}</div>
                  <div className={classes.compQtyLabel}>
                    {props.solution ? "" : formatNumber(props.compQuantity)}
                  </div>
                )
              ) : null}
            </TableCell>
            <TableCell>
              {/* {props.providerType === 'SALES_CHNL_PROVIDER' &&
                        (
                            props.price.recurringPrice
                                ?
                                '' + (props.name ? props.name : props.productName) + ' ( ' + (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) + ' X ' + currencyFormatter(props.price.recurringPrice.price) + ' )'
                                :
                                (props.price.purchasePrice
                                    ?
                                    '' + (props.name ? props.name : props.productName) + ' ( ' + (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) + ' X ' + currencyFormatter(props.price.purchasePrice) + ' )'
                                    :
                                    '' + (props.name ? props.name : props.productName) + ' ( ' + (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) + ' X ' + currencyFormatter('', false) + '0.00 )'
                                )
                        )
                    } */}
              {/* {props.providerType !== 'SALES_CHNL_PROVIDER' &&
                        (
                            (props.name ? props.name : props.productName)
                        )
                    } */}
              <b>{props.name ? props.name : props.productName}</b>
            </TableCell>
            {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
              props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                <TableCell>{/* Discount Cell */}</TableCell>
              )}
            {props.orderStatus === "ORDER_COMPLETED" && (
              <TableCell>{props.pcoSeqNum}</TableCell>
            )}
            <TableCell></TableCell>
            {props.providerType === "SALES_CHNL_PROVIDER" ? (
              <>
                <TableCell align="right">
                  {/* {props.nonRecurringCost ?
                                (parseInt(props.nonRecurringCost) === 0 && props.dontShowZero) ? '' : currencyFormatter((Math.round(props.nonRecurringCost * (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) * 100) / 100).toFixed(2))
                                :
                                !props.price.recurringPrice && props.price.purchasePrice
                                    ?
                                    (parseInt(props.price.purchasePrice) === 0 && props.dontShowZero) ? '' : currencyFormatter((Math.round(props.price.purchasePrice * (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) * 100) / 100).toFixed(2))
                                    :
                                    currencyFormatter('', false) + '0.00'
                            } */}
                </TableCell>
                {/* <TableCell align="right">
                            {props.recurringCost ?
                                (parseInt(props.recurringCost) === 0 && props.dontShowZero) ? '' : currencyFormatter((Math.round(props.recurringCost * (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) * 100) / 100).toFixed(2))
                                :
                                props.price.recurringPrice
                                    ?
                                    (parseInt(props.price.recurringPrice.price) === 0 && props.dontShowZero) ? '' : currencyFormatter((Math.round(props.price.recurringPrice.price * (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) * 100) / 100).toFixed(2))
                                    :
                                    currencyFormatter('', false) + '0.00'
                            }
                        </TableCell> */}
              </>
            ) : (
              <>
                <TableCell></TableCell>
                {/* <TableCell>&nbsp;</TableCell> */}
                {/* <TableCell>&nbsp;</TableCell> */}
              </>
            )}
            {props.providerType === "SALES_CHNL_PROVIDER" ? (
              <>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </>
            ) : (
              <>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
              </>
            )}
          </TableRow>
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            props.nonRecurringCost &&
            Number(props.nonRecurringCost) > 0 ? (
            <TableRow>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <span style={{ paddingLeft: "20px" }}>
                  {props.t("NRC_FULL")}
                </span>
              </TableCell>
              {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                  <TableCell>{/* Discount Cell */}</TableCell>
                )}
              {props.orderStatus === "ORDER_COMPLETED" && (
                <TableCell>{props.pcoSeqNum}</TableCell>
              )}
              <TableCell></TableCell>
              <TableCell align="right">
                {currencyFormatter(props.nonRecurringCost)}
              </TableCell>
              <TableCell align="right">
                <span title={props.t("QUANTITY")}>
                  {formatNumber(props.compQuantity * props.quantity)}
                </span>
              </TableCell>
              <TableCell align="right">
                {props.providerType === "SALES_CHNL_PROVIDER" ? (
                  <>
                    {parseInt(props.nonRecurringCost) === 0 &&
                      props.dontShowZero
                      ? ""
                      : currencyFormatter(
                        (
                          Math.round(
                            props.nonRecurringCost *
                            (props.oldOrder
                              ? props.compQuantity
                              : props.compQuantity * props.quantity) *
                            100,
                          ) / 100
                        ).toFixed(2),
                      )}
                  </>
                ) : (
                  currencyFormatter("", false) + "0.00"
                )}
              </TableCell>
              {/* <TableCell align='right'>
                        {currencyFormatter('', false) + '0.00'}
                    </TableCell> */}
            </TableRow>
          ) : (
            ""
          )}
          {/* {props.providerType === 'SALES_CHNL_PROVIDER' && (props.recurringCost && Number(props.recurringCost) > 0) ?
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell>
                                <span style={{ paddingLeft: '20px' }}>
                                    {props.t('RC_FULL')}
                                    {props.chargeTerm &&
                                        (props.chargeTerm.termPeriod ? props.chargeTerm.termPeriod > 1 ?
                                            ' (' + 'per ' + props.chargeTerm.termPeriod + ' ' + getPriceTenureUOM(props.chargeTerm.termUomId) + 's' + ')' :
                                            ' (' + 'per ' + getPriceTenureUOM(props.chargeTerm.termUomId) + ')' : '')
                                    }
                                </span>
                            </TableCell>
                            {(props.loggedInUserType !== 'ECOMMERCE_CUSTOMER' || props.loggedInUserType !== 'ECOMMERCE_ADMIN') &&
                                <TableCell>
                                </TableCell>

                            }
                            {
                                props.orderStatus === 'ORDER_COMPLETED' &&
                                <TableCell>{props.pcoSeqNum}</TableCell>
                            }
                            <TableCell align='right'>
                                {currencyFormatter((props.recurringCost))}
                            </TableCell>
                            <TableCell align='right'>
                                <span title={props.t('QUANTITY')}>
                                    {props.compQuantity * props.quantity}
                                </span>
                            </TableCell>
                            <TableCell align='right'>
                                {props.providerType === 'SALES_CHNL_PROVIDER' ?
                                    <>
                                        {(parseInt(props.recurringCost) === 0 && props.dontShowZero) ? '' : currencyFormatter((Math.round(props.recurringCost * (props.oldOrder ? props.compQuantity : props.compQuantity * props.quantity) * 100) / 100).toFixed(2))}
                                    </>
                                    :
                                    currencyFormatter('', false) + '0.00'
                                }
                            </TableCell>
                        </TableRow>
                        :
                        ''
                    } */}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            props.recurringCost &&
            props.recurringCost.length > 0 &&
            props.recurringCost.map((charge, index) => {
              const { key, termPeriod, tenureUom, amount } = charge;
              const displayText =
                termPeriod > 1
                  ? `${props.t("RC_FULL")} (per ${termPeriod} ${getPriceTenureUOM(tenureUom)}s)`
                  : `${props.t("RC_FULL")} (per ${getPriceTenureUOM(tenureUom)})`;

              return (
                amount > 0 && (
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      <span style={{ paddingLeft: "20px" }}>{displayText}</span>
                    </TableCell>
                    {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                      props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                        <TableCell></TableCell>
                      )}
                    {props.orderStatus === "ORDER_COMPLETED" && (
                      <TableCell>{props.pcoSeqNum}</TableCell>
                    )}
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {currencyFormatter(amount)}
                    </TableCell>
                    <TableCell align="right">
                      <span title={props.t("QUANTITY")}>
                        {formatNumber(props.compQuantity * props.quantity)}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {props.providerType === "SALES_CHNL_PROVIDER" ? (
                        <>
                          {parseInt(amount) === 0 && props.dontShowZero
                            ? ""
                            : currencyFormatter(
                              (
                                Math.round(
                                  amount *
                                  (props.oldOrder
                                    ? props.compQuantity
                                    : props.compQuantity * props.quantity) *
                                  100,
                                ) / 100
                              ).toFixed(2),
                            )}
                        </>
                      ) : (
                        currencyFormatter("", false) + "0.00"
                      )}
                    </TableCell>
                  </TableRow>
                )
              );
            })}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            !props.recurringCost &&
            !props.nonRecurringCost && (
              <>
                {!props.price.recurringPrice &&
                  Number(props.price.purchasePrice) > 0 && (
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell>
                        <span style={{ paddingLeft: "20px" }}>
                          {props.chargeType === "NTC"
                            ? props.chargeTerm.termPeriod > 1
                              ? `${props.t("NTC_FULL")} (per ${getPriceTenureUOM(props.chargeTerm.termUomId)} for ${props.chargeTerm.termPeriod
                              } ${getPriceTenureUOM(props.chargeTerm.termUomId)}s)`
                              : `${props.t("NTC_FULL")} (per ${getPriceTenureUOM(props.chargeTerm.termUomId)} for ${props.chargeTerm.termPeriod
                              } ${getPriceTenureUOM(props.chargeTerm.termUomId)})`
                            : props.t("NRC_FULL")}
                        </span>
                      </TableCell>
                      {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                        props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                          <TableCell>{/* Discount Cell */}</TableCell>
                        )}
                      {props.orderStatus === "ORDER_COMPLETED" && (
                        <TableCell>{props.pcoSeqNum}</TableCell>
                      )}
                      <TableCell></TableCell>
                      <TableCell align="right">
                        {currencyFormatter(props.price.purchasePrice)}
                      </TableCell>
                      <TableCell align="right">
                        <span title={props.t("QUANTITY")}>
                          {formatNumber(props.compQuantity * props.quantity)}
                        </span>
                      </TableCell>
                      <TableCell align="right">
                        {props.providerType === "SALES_CHNL_PROVIDER"
                          ? parseInt(props.price.purchasePrice) === 0 &&
                            props.dontShowZero
                            ? ""
                            : currencyFormatter(
                              (
                                Math.round(
                                  props.price.purchasePrice *
                                  (props.oldOrder
                                    ? props.compQuantity
                                    : props.compQuantity * props.quantity) *
                                  100,
                                ) / 100
                              ).toFixed(2),
                            )
                          : currencyFormatter("", false) + "0.00"}
                      </TableCell>
                      {/* <TableCell align='right'>
                        {currencyFormatter('', false) + '0.00'}
                    </TableCell> */}
                    </TableRow>
                  )}
                {props.price.recurringPrice &&
                  Number(props.price.recurringPrice.price) > 0 && (
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell>
                        <span style={{ paddingLeft: "20px" }}>
                          {props.t("RC_FULL")}
                          {props.chargeTerm &&
                            (props.chargeTerm.termPeriod
                              ? props.chargeTerm.termPeriod > 1
                                ? " (" +
                                "per " +
                                props.chargeTerm.termPeriod +
                                " " +
                                getPriceTenureUOM(
                                  props.chargeTerm.termUomId,
                                ) +
                                "s" +
                                ")"
                                : " (" +
                                "per " +
                                getPriceTenureUOM(
                                  props.chargeTerm.termUomId,
                                ) +
                                ")"
                              : "")}
                        </span>
                      </TableCell>
                      {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                        props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                          <TableCell>{/* Discount Cell */}</TableCell>
                        )}
                      {props.orderStatus === "ORDER_COMPLETED" && (
                        <TableCell>{props.pcoSeqNum}</TableCell>
                      )}
                      <TableCell></TableCell>
                      <TableCell align="right">
                        {currencyFormatter(props.price.recurringPrice.price)}
                      </TableCell>
                      <TableCell align="right">
                        <span title={props.t("QUANTITY")}>
                          {formatNumber(props.compQuantity * props.quantity)}
                        </span>
                      </TableCell>
                      <TableCell align="right">
                        {props.providerType === "SALES_CHNL_PROVIDER"
                          ? parseInt(props.price.recurringPrice.price) === 0 &&
                            props.dontShowZero
                            ? ""
                            : currencyFormatter(
                              (
                                Math.round(
                                  props.price.recurringPrice.price *
                                  (props.oldOrder
                                    ? props.compQuantity
                                    : props.compQuantity * props.quantity) *
                                  100,
                                ) / 100
                              ).toFixed(2),
                            )
                          : currencyFormatter("", false) + "0.00"}
                      </TableCell>
                      {/* <TableCell align='right'>
                        {currencyFormatter('', false) + '0.00'}
                    </TableCell> */}
                    </TableRow>
                  )}
              </>
            )}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            props.depositPrice &&
            Number(props.depositPrice) > 0 && (
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <span style={{ paddingLeft: "20px" }}>
                    {props.t("DEPOSIT_PRICE")}
                  </span>
                </TableCell>
                {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                    <TableCell>{/* Discount Cell */}</TableCell>
                  )}
                {props.orderStatus === "ORDER_COMPLETED" && (
                  <TableCell>{props.pcoSeqNum}</TableCell>
                )}
                <TableCell></TableCell>
                <TableCell align="right">
                  {currencyFormatter(props.depositPrice)}
                </TableCell>
                <TableCell align="right">
                  <span title={props.t("QUANTITY")}>
                    {formatNumber(props.compQuantity * props.quantity)}
                  </span>
                </TableCell>
                <TableCell align="right">
                  {props.providerType === "SALES_CHNL_PROVIDER" ? (
                    <>
                      {parseInt(props.depositPrice) === 0 && props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.depositPrice *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </>
                  ) : (
                    currencyFormatter("", false) + "0.00"
                  )}
                </TableCell>
                {/* <TableCell align='right'>
                        {currencyFormatter('', false) + '0.00'}
                    </TableCell> */}
              </TableRow>
            )}
          {/* cancellation price  */}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            props.cancellationPrice &&
            Number(props.cancellationPrice) > 0 && (
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <span style={{ paddingLeft: "20px" }}>
                    {props.t("CANCELLATION_PRICE")}
                  </span>
                </TableCell>
                {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                    <TableCell>{/* Discount Cell */}</TableCell>
                  )}
                {props.orderStatus === "ORDER_COMPLETED" && (
                  <TableCell>{props.pcoSeqNum}</TableCell>
                )}
                <TableCell></TableCell>
                <TableCell align="right">
                  {currencyFormatter(props.cancellationPrice)}
                </TableCell>
                <TableCell align="right">
                  <span title={props.t("QUANTITY")}>
                    {formatNumber(props.compQuantity * props.quantity)}
                  </span>
                </TableCell>
                <TableCell align="right">
                  {props.providerType === "SALES_CHNL_PROVIDER" ? (
                    <>
                      {parseInt(props.cancellationPrice) === 0 &&
                        props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.cancellationPrice *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </>
                  ) : (
                    currencyFormatter("", false) + "0.00"
                  )}
                </TableCell>
                {/* <TableCell align='right'>
                        {currencyFormatter('', false) + '0.00'}
                    </TableCell> */}
              </TableRow>
            )}

          {props.providerType === "SALES_CHNL_PROVIDER" &&
            props.setupFee &&
            Number(props.setupFee) > 0 && (
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <span style={{ paddingLeft: "20px" }}>
                    {props.t("SETUP_FEE")}
                  </span>
                </TableCell>
                {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                    <TableCell>{/* Discount Cell */}</TableCell>
                  )}
                {props.orderStatus === "ORDER_COMPLETED" && (
                  <TableCell>{props.pcoSeqNum}</TableCell>
                )}
                <TableCell></TableCell>
                <TableCell align="right">
                  {currencyFormatter(props.setupFee)}
                </TableCell>
                <TableCell align="right">
                  <span title={props.t("QUANTITY")}>
                    {formatNumber(props.compQuantity * props.quantity)}
                  </span>
                </TableCell>
                <TableCell align="right">
                  {props.providerType === "SALES_CHNL_PROVIDER" ? (
                    <>
                      {parseInt(props.setupFee) === 0 && props.dontShowZero
                        ? ""
                        : currencyFormatter(
                          (
                            Math.round(
                              props.setupFee *
                              (props.oldOrder
                                ? props.compQuantity
                                : props.compQuantity * props.quantity) *
                              100,
                            ) / 100
                          ).toFixed(2),
                        )}
                    </>
                  ) : (
                    currencyFormatter("", false) + "0.00"
                  )}
                </TableCell>
                {/* <TableCell align='right'>
                        {currencyFormatter('', false) + '0.00'}
                    </TableCell> */}
              </TableRow>
            )}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            !props.recurringCost &&
            !props.nonRecurringCost &&
            props.otherPrices &&
            props.otherPrices.length > 0 &&
            props.otherPrices.map(
              (op, opx) =>
                Number(op.price) > 0 &&
                op.priceType !== "CANCELLATION_PRICE" && (
                  <TableRow key={opx}>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      <span style={{ paddingLeft: "20px" }}>
                        {props.t(op.priceType)}
                      </span>
                      {op.priceTenure !== null && op.priceTenureUOM && (
                        <span>
                          {op.priceTenure > 1
                            ? ` (per ${op.priceTenure} ${props.getPriceTenureUOM(op.priceTenureUOM)}s)`
                            : ` (per ${props.getPriceTenureUOM(op.priceTenureUOM)})`}
                        </span>
                      )}
                    </TableCell>
                    {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                      props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                        <TableCell>{/* Discount Cell */}</TableCell>
                      )}
                    {props.orderStatus === "ORDER_COMPLETED" && (
                      <TableCell>{props.pcoSeqNum}</TableCell>
                    )}
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {currencyFormatter(op.price)}
                    </TableCell>
                    <TableCell align="right">
                      <span title={props.t("QUANTITY")}>
                        {formatNumber(props.oldOrder
                          ? props.compQuantity
                          : props.compQuantity * props.quantity)}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {props.providerType === "SALES_CHNL_PROVIDER" ? (
                        <>
                          {parseInt(op.price) === 0 && props.dontShowZero
                            ? ""
                            : currencyFormatter(
                              (
                                Math.round(
                                  op.price *
                                  (props.oldOrder
                                    ? props.compQuantity
                                    : props.compQuantity * props.quantity) *
                                  100,
                                ) / 100
                              ).toFixed(2),
                            )}
                        </>
                      ) : (
                        currencyFormatter("", false) + "0.00"
                      )}
                    </TableCell>
                    {/* <TableCell align='right'>
                            {currencyFormatter('', false) + '0.00'}
                        </TableCell> */}
                  </TableRow>
                ),
            )}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            !props.recurringCost &&
            !props.nonRecurringCost &&
            props.otherPrices &&
            props.otherPrices.length > 0 &&
            props.otherPrices.map(
              (op, opx) =>
                Number(op.price) > 0 &&
                op.priceType === "CANCELLATION_PRICE" && (
                  <TableRow key={opx}>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      <span style={{ paddingLeft: "20px" }}>
                        {props.t(op.priceType)}
                      </span>
                      {op.priceTenure !== null && op.priceTenureUOM && (
                        <span>
                          {op.priceTenure > 1
                            ? ` (per ${op.priceTenure} ${props.getPriceTenureUOM(op.priceTenureUOM)}s)`
                            : ` (per ${props.getPriceTenureUOM(op.priceTenureUOM)})`}
                        </span>
                      )}
                    </TableCell>
                    {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                      props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                        <TableCell>{/* Discount Cell */}</TableCell>
                      )}
                    {props.orderStatus === "ORDER_COMPLETED" && (
                      <TableCell>{props.pcoSeqNum}</TableCell>
                    )}
                    <TableCell></TableCell>
                    <TableCell align="right">
                      {currencyFormatter(op.price)}
                    </TableCell>
                    <TableCell align="right">
                      <span title={props.t("QUANTITY")}>
                        {formatNumber(props.oldOrder
                          ? props.compQuantity
                          : props.compQuantity * props.quantity)}
                      </span>
                    </TableCell>
                    <TableCell align="right">
                      {props.providerType === "SALES_CHNL_PROVIDER" ? (
                        <>
                          {parseInt(op.price) === 0 && props.dontShowZero
                            ? ""
                            : currencyFormatter(
                              (
                                Math.round(
                                  op.price *
                                  (props.oldOrder
                                    ? props.compQuantity
                                    : props.compQuantity * props.quantity) *
                                  100,
                                ) / 100
                              ).toFixed(2),
                            )}
                        </>
                      ) : (
                        currencyFormatter("", false) + "0.00"
                      )}
                    </TableCell>
                    {/* <TableCell align='right'>
                            {currencyFormatter('', false) + '0.00'}
                        </TableCell> */}
                  </TableRow>
                ),
            )}
          {props.providerType === "SALES_CHNL_PROVIDER" &&
            props.bom &&
            props.bom.length > 0 && (
              <TableRow>
                <TableCell colSpan={8}>
                  <Collapse in={true}>
                    {props.bom
                      .sort((a, b) =>
                        a && b ? a.displaySequence - b.displaySequence : 0,
                      )
                      .map((bom, index) => (
                        <div
                          key={bom.id}
                          style={{ marginLeft: "200px", marginRight: "36px" }}
                        >
                          <BomItem
                            data={bom}
                            index={index}
                            t={props.t}
                            parentItem={props}
                            level={1}
                            toggleInventoryDialog={props.toggleInventoryDialog}
                          />
                        </div>
                      ))}
                  </Collapse>
                </TableCell>
              </TableRow>
            )}
        </>
      ) : (
        <>
          <TableRow>
            <TableCell>&nbsp;</TableCell>
            <TableCell
              style={{
                width:
                  props.providerType === "SALES_CHNL_PROVIDER"
                    ? "auto"
                    : "40px",
              }}
            >
              {props.compQuantity && props.compQuantity > 0 ? (
                props.editQuantity && props.quantityModifiable ? (
                  // Check if component quantity is allowed to change
                  <React.Fragment>
                    {/* Remove packaged solution */}
                    <button
                      onClick={() => {
                        props.remove(
                          props.solutionIndex,
                          props.itemType,
                          props.compType,
                          props.compIndex,
                        );
                      }}
                      className={classes.button}
                    >
                      {props.t("REMOVE")}
                    </button>
                    <Input
                      className={classes.compQtyCell}
                      type="number"
                      min="1"
                      step="1"
                      value={props.compQuantity}
                      onChange={(e) => {
                        props.changeQuantity(
                          e.target.value,
                          props.solutionIndex,
                          props.itemType,
                          props.compType,
                          props.compIndex,
                        );
                      }}
                      style={{ background: "#fff" }}
                    />
                  </React.Fragment>
                ) : (
                  <div className={classes.compQtyLabel}>
                    {props.solution ? "" : formatNumber(props.compQuantity * props.quantity)}
                  </div>
                )
              ) : null}
            </TableCell>
            <TableCell>
              {props.providerType === "SALES_CHNL_PROVIDER" &&
                (props.price.recurringPrice
                  ? "" +
                  (props.name ? props.name : props.productName) +
                  " ( " +
                  (props.oldOrder
                    ? props.compQuantity
                    : props.compQuantity * props.quantity) +
                  " X " +
                  currencyFormatter(props.price.recurringPrice.price) +
                  " )"
                  : props.price.purchasePrice
                    ? "" +
                    (props.name ? props.name : props.productName) +
                    " ( " +
                    (props.oldOrder
                      ? props.compQuantity
                      : props.compQuantity * props.quantity) +
                    " X " +
                    currencyFormatter(props.price.purchasePrice) +
                    " )"
                    : "" +
                    (props.name ? props.name : props.productName) +
                    " ( " +
                    (props.oldOrder
                      ? props.compQuantity
                      : props.compQuantity * props.quantity) +
                    " X " +
                    currencyFormatter("", false) +
                    "0.00 )")}
              {props.providerType !== "SALES_CHNL_PROVIDER" &&
                (props.name ? props.name : props.productName)}
            </TableCell>
            {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
              props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                <TableCell>{/* Discount Cell */}</TableCell>
              )}
            {props.orderStatus === "ORDER_COMPLETED" && (
              <TableCell>{props.pcoSeqNum}</TableCell>
            )}
            <TableCell>{/* placeholder for client column */}</TableCell>
            {props.providerType === "SALES_CHNL_PROVIDER" ? (
              <>
                <TableCell align="right">
                  {!props.price.recurringPrice && props.price.purchasePrice
                    ? parseInt(props.price.purchasePrice) === 0 &&
                      props.dontShowZero
                      ? ""
                      : currencyFormatter(
                        (
                          Math.round(
                            props.price.purchasePrice *
                            (props.oldOrder
                              ? props.compQuantity
                              : props.compQuantity * props.quantity) *
                            100,
                          ) / 100
                        ).toFixed(2),
                      )
                    : currencyFormatter("", false) + "0.00"}
                </TableCell>
                <TableCell align="right">
                  {props.price.recurringPrice
                    ? parseInt(props.price.recurringPrice.price) === 0 &&
                      props.dontShowZero
                      ? ""
                      : currencyFormatter(
                        (
                          Math.round(
                            props.price.recurringPrice.price *
                            (props.oldOrder
                              ? props.compQuantity
                              : props.compQuantity * props.quantity) *
                            100,
                          ) / 100
                        ).toFixed(2),
                      )
                    : currencyFormatter("", false) + "0.00"}
                </TableCell>
              </>
            ) : (
              <>
                <TableCell>&nbsp;</TableCell>
                <TableCell>&nbsp;</TableCell>
              </>
            )}
          </TableRow>
          {props.serializedInventory &&
            props.serializedInventory.length > 0 && (
              <TableRow>
                <TableCell colSpan={7}>
                  <Collapse in={true}>
                    {props.serializedInventory.map((item, index) => (
                      <span key={index}>{item}</span>
                    ))}
                  </Collapse>
                </TableCell>
              </TableRow>
            )}
          {props.bom && props.bom.length > 0 && (
            <TableRow>
              <TableCell colSpan={7}>
                <Collapse in={true}>
                  {props.bom
                    .sort((a, b) =>
                      a && b ? a.displaySequence - b.displaySequence : 0,
                    )
                    .map((bom, index) => (
                      <div
                        key={bom.id}
                        style={{ marginLeft: "200px", marginRight: "36px" }}
                      >
                        <BomItem
                          data={bom}
                          index={index}
                          t={props.t}
                          parentItem={props}
                          level={1}
                          toggleInventoryDialog={props.toggleInventoryDialog}
                        />
                      </div>
                    ))}
                </Collapse>
              </TableCell>
            </TableRow>
          )}
        </>
      )}
      {showHierarchy && (
        <Dialog
          disableScrollLock={true}
          maxWidth={"sm"}
          PaperComponent={DraggableDialogPaper}
          fullWidth={true}
          open={showHierarchy}
          aria-labelledby="import-dialog-title"
        // PaperProps={{
        // 	className: props.classess.resizablePaper
        // }}
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {props.t("SELECT_CUSTOMER")}
          </DialogTitle>
          <DialogContent dividers style={{ height: "500px" }}>
            <ManageCustomersHierarchy
              screen="products"
              subScreen="oldOfferingFilter"
              selectCustomers={selectCustomers}
              customerData={selectedCustomer}
              offeringBan={props.orderCustomer.ban}
            // offeringCustomer={[props.orderCustomer.clientId]}
            // stage={this.state.stage}
            // next={this.selectCustomerClose}
            // // back={this.back}
            // selectedTreeItems={this.state.selectedTreeItems}
            // customerDetails={this.state.customerDetails}
            // selectedPaymentMethod={this.state.selectedPaymentMethod}
            // resetSelecteddata={this.resetSelecteddata}
            // closeDialog={this.closeDialog}
            // parentTenantId={this.state.parentTenantId}

            // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? [this.props.ecommerceCustData.partyId] : this.state.offeringCustomersList}
            />
          </DialogContent>
          <DialogActions>
            <ButtonComponent onClick={() => toggleShowHierarchy(false)}>
              {props.t("CANCEL")}
            </ButtonComponent>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

const SellableClientColumn = (props) => {
  const [showHierarchy, toggleShowHierarchy] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [mode, setmode] = useState("ADD");
  const [isReadOnly, setReadOnly] = useState(false);
  useEffect(() => {
    if (props.locationDetail && props.locationDetail.partyId) {
      setSelectedCustomer([props.locationDetail]);
    }
  }, []);
  const DraggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };
  const selectCustomers = (data) => {
    toggleShowHierarchy(false);
    props.updateLineItemClient(props.packageId, props.id, data.partyId, mode);
    setmode("ADD");
    // if (mode === 'edit') {
    //     var tempData = {
    //         partyId: data.partyId,
    //         name: data.name
    //     }
    //     setSelectedCustomer([tempData]);
    //     props.editCustomer(props.orderItemSeqId, data.partyId)
    // } else {
    //     var tempData = {
    //         partyId: data.partyId,
    //         name: data.name
    //     }
    //     setSelectedCustomer([tempData]);
    // }
    // setmode('add');
  };
  const editCustomer = () => {
    setmode("MODIFY");
    toggleShowHierarchy(true);
  };
  const clearCustomer = () => {
    props.updateLineItemClient(
      props.packageId,
      props.id,
      selectedCustomer[0].partyId,
      "DELETE",
    );
    // setSelectedCustomer([]);
    // props.clearCustomer(props.orderItemSeqId, selectedCustomer[0].partyId, 'DELETE')
  };
  return (
    <>
      {props.priceSummaryView ? (
        <>
          {props.orderType && props.orderType === "ShiftSubscription" ? (
            <div>
              {selectedCustomer && selectedCustomer.length > 0 ? (
                <>
                  <span style={{ position: "relative", top: "-5px" }}>
                    {selectedCustomer[0].name}
                  </span>
                </>
              ) : (
                <></>
              )}
            </div>
          ) : null}
        </>
      ) : (
        <TableCell>
          {selectedCustomer && selectedCustomer.length > 0 ? (
            <>
              <span style={{ position: "relative", top: "-5px" }}>
                {selectedCustomer[0].name}
              </span>
              {props.providerType === "SALES_CHNL_PROVIDER" &&
                window.location.pathname.includes("/order/") ? (
                <>
                  &nbsp; &nbsp;
                  <span style={{ color: props.tenantData.color }}>
                    <Tooltip title={props.t("CHANGE")}>
                      <EditIcon onClick={() => editCustomer()} />
                    </Tooltip>
                    <Tooltip title={props.t("CLEAR")}>
                      <ClearIconMUI onClick={() => clearCustomer()} />
                    </Tooltip>
                  </span>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {props.providerType === "SALES_CHNL_PROVIDER" &&
                window.location.pathname.includes("/order/") ? (
                <span style={{ color: props.tenantData.color }}>
                  <Tooltip title={props.t("ADD")}>
                    <AddIcon onClick={() => toggleShowHierarchy(true)} />
                  </Tooltip>
                </span>
              ) : (
                ""
              )}
            </>
          )}
        </TableCell>
      )}
      {showHierarchy && (
        <Dialog
          disableScrollLock={true}
          maxWidth={"sm"}
          PaperComponent={DraggableDialogPaper}
          fullWidth={true}
          open={showHierarchy}
          aria-labelledby="import-dialog-title"
        >
          <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
            {props.t("SELECT_CUSTOMER")}
          </DialogTitle>
          <DialogContent dividers style={{ height: "500px" }}>
            <ManageCustomersHierarchy
              screen="products"
              subScreen="oldOfferingFilter"
              selectCustomers={selectCustomers}
              customerData={selectedCustomer}
              offeringBan={props.orderCustomer.ban}
            // offeringCustomer={[props.orderCustomer.clientId]}
            // stage={this.state.stage}
            // next={this.selectCustomerClose}
            // // back={this.back}
            // selectedTreeItems={this.state.selectedTreeItems}
            // customerDetails={this.state.customerDetails}
            // selectedPaymentMethod={this.state.selectedPaymentMethod}
            // resetSelecteddata={this.resetSelecteddata}
            // closeDialog={this.closeDialog}
            // parentTenantId={this.state.parentTenantId}

            // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? [this.props.ecommerceCustData.partyId] : this.state.offeringCustomersList}
            />
          </DialogContent>
          <DialogActions>
            <ButtonComponent onClick={() => toggleShowHierarchy(false)}>
              {props.t("CANCEL")}
            </ButtonComponent>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

const SerializedItemNumbers = (props) => {
  const [open, toggleOpen] = useState(false);
  return (
    <Collapse in={true}>
      <TableContainer>
        <Table style={{ width: "100%" }} className="noPaddingTd">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>
                {props.t("SERIAL_NUMBER")}
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>
                {props.t("LOT_ID")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((item, index) => (
              <TableRow key={index}>
                <TableCell style={{ paddingRight: 0 }}>
                  {item.serialNumber}
                </TableCell>
                <TableCell style={{ paddingRight: 0 }}>{item.lotId}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Collapse>
  );
};

const BomItemNew = (bom) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: `${(bom.level - 1) * 4}rem`,
          flexDirection: "row",
        }}
      >
        <EnterArrow />
        <div>
          <b> {bom.data.name}</b>
          {bom.t("QUANTITY")}: (
          {bom.data.presetQuantity
            ? bom.data.presetQuantity * bom.parentItem.quantity
            : 1 * bom.parentItem.quantity}
          )
        </div>
        <div>
          {bom.data.inventoryDetail && bom.data.inventoryDetail.length > 0 && (
            <Tooltip
              title={bom.t("VIEW_INVENTORY")}
              onClick={(e) => {
                bom.toggleInventoryDialog(
                  bom.data.name,
                  bom.data.inventoryDetail,
                );
              }}
            >
              <IconButton className="buttonSecondary">
                <ViewIconNew />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      {bom.data.bom &&
        bom.data.bom.length > 0 &&
        bom.data.bom
          .sort((a, b) => (a && b ? a.displaySequence - b.displaySequence : 0))
          .map((child) => (
            <BomItemNew
              data={child}
              parentItem={bom.parentItem}
              level={bom.level + 1}
              t={bom.t}
              toggleInventoryDialog={bom.toggleInventoryDialog}
            />
          ))}
    </div>
  );
};
const BomItem = (bom) => {
  return (
    bom.data.customerViewable && (
      <div
        style={{
          padding: "5px 25px 0",
          paddingTop: bom.index === 0 ? 0 : "5px",
          paddingLeft: bom.level === 1 ? 0 : "60px",
        }}
      >
        <TableContainer>
          <Table style={{ width: "100%" }} className="noPaddingTd">
            <TableBody>
              <TableRow>
                <TableCell style={{ paddingRight: 0 }}>
                  {/* <div style={{ width: '60px', float: 'left' }}>
								<Input
									className={classes.quantityInput}
									value={bom.data.presetQuantity ? bom.data.presetQuantity * bom.parentItem.quantity : 1 * bom.parentItem.quantity}
									disabled={true}
								/>
							</div> */}
                  <div
                    style={{
                      width: "calc(100% - 60px)",
                      float: "left",
                      lineHeight: "28px",
                      display: "inline-flex",
                    }}
                  >
                    {bom.data.name}&nbsp;
                    <span title={bom.t("QUANTITY")}>
                      (
                      {bom.data.presetQuantity
                        ? bom.data.presetQuantity * bom.parentItem.quantity
                        : 1 * bom.parentItem.quantity}
                      )
                    </span>
                    {bom.data.inventoryDetail &&
                      bom.data.inventoryDetail.length > 0 && (
                        <span
                          style={{
                            position: "relative",
                            marginLeft: "10px",
                            top: "3px",
                          }}
                        >
                          <Tooltip
                            title={bom.t("VIEW_INVENTORY")}
                            onClick={(e) => {
                              bom.toggleInventoryDialog(
                                bom.data.name,
                                bom.data.inventoryDetail,
                              );
                            }}
                          >
                            {/* <VisibilityIcon /> */}
                            <IconButton className="buttonSecondary">
                              <ViewIconNew />
                            </IconButton>
                          </Tooltip>
                        </span>
                      )}
                  </div>
                </TableCell>
                {/* <td>
							{bom.data.name}
						</td> */}
                {/* <td style={{ width: '10%', textAlign: 'right' }}>{bom.data.price}</td> */}
              </TableRow>
              {/* {bom.data.inventoryDetail && bom.data.inventoryDetail.length > 0 &&
						<tr>
							<td>
								<SerializedItemNumbers data={bom.data.inventoryDetail} t={bom.t} />
							</td>
						</tr>
					} */}
            </TableBody>
          </Table>
        </TableContainer>
        {bom.data.bom &&
          bom.data.bom.length > 0 &&
          bom.data.bom
            .sort((a, b) =>
              a && b ? a.displaySequence - b.displaySequence : 0,
            )
            .map((child) => (
              <BomItem
                data={child}
                parentItem={bom.parentItem}
                level={bom.level + 1}
                t={bom.t}
                toggleInventoryDialog={bom.toggleInventoryDialog}
              />
            ))}
      </div>
    )
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    quoteEnabled: state.auth.quoteEnabled,
    priceSummaryView: state.auth.priceSummaryView,
    tenantData: state.auth.tenantData,
    userPerms: state.auth.userPerms,
    providerType: state.auth.providerType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(CartBlock));
